import {
	Button,
	Card,
	Pagination,
	Affix,
	List,
	Tabs,
	Steps,
	Radio,
	Drawer,
	Layout,
	Table,
	Tag,
	Dropdown,
	Modal,
	Form,
	Select,
	Switch,
	AutoComplete,
	Input,
	Upload,
	DatePicker,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import Container from 'react-bootstrap/Container';
import { CardImg } from 'react-bootstrap';
const { Search } = Input;
const { Dragger } = Upload;
export const Theme = {
	colors: {
		white: '#FFFFFF',
		bodyBg: '#F4F6F9',
		themeColor1: '#212226',
		themeColor2: '#081D16',
		themeColor3: '#757575',
		themeColor4: '#7F8E89',
		themeColor5: '#11263C',

		themeColor7: '#0093AB',
		themeColor8: '#007299',
		themeColor9: '#48CF99',
		themeColor10: '#B3454B',
		themeColor11: '#6271B0',
		themeColor12: '#ED982A',
		themeColor13: '#00B2AA',

		themeColor14: '#D5001A',
		themeColor15: '#FF6A00',
		themeColor16: '#E5AA11',
		themeColor17: '#1F9254',

		themeColor18: '#B5BDEB',
		themeColor19: '#DCA5FC',
		themeColor20: '#E8EAF3',
		themeColor21: '#F0E5F6',

		themeColor22: '#ECECEC',
		themeColor23: '#D0E0DF',
		themeColor24: '#333333',
		themeColor25: '#7ee6e9',
		themeColor26: '#F7F9FD',
		themeColor27: '#F7F9FD',
		themeColor28: '#D8D8D7',
		themeColor29: '#e5f1f5',
		themeColor30: '#E57711',
		themeColor31: '#DB3A17',
		themeColor32: '#F7F8FA',
		themeColor33: '#505887',

		themeTagColor1: '#fdf5ea',
		themeTagColor2: '#f7eced',

		fontPoppins: `'Poppins', sans-serif !important;`,
		//fontPoppins2: `'Poppins', sans-serif !important;`,
		fontDM: "'DM Sans', sans-serif !important ",
		fontInter: "'Inter', sans-serif !important ",

		/*Below is old color code*/
		menu1: '#a7a7a7',
		menu2: '#212226',
		color1: '#757575',
		color2: '#081D16',
		color3: '#d0e0df',
		color4: '#7f8e89',
		color5: '#f8f8f8',
		color6: '#dadee3',
		color7: '#11263c',
		color8: '#868FA0',
		color9: '#687182',
		color10: '#9B68BF',
		color12: '#57636F',
	},
	media: { mobile: '768px', tab: '998px' },

	CQColors: {
		white: '#FFFFFF',
		bodyBg: '#F4F6F9',
		themeColor1: '#169191',
		themeColor2: '#1A2E40',
		themeColor3: '#71717A',

		// fontPoppins: `'Poppins', sans-serif !important;`,
		// fontDM: "'DM Sans', sans-serif !important ",
		fontInter: "'Inter', sans-serif !important ",

		/*Below is old color code*/
		// menu1: '#a7a7a7',
		// menu2: '#212226',
	},
};
export const XThemeLayout = styled(Layout)`
	background: none !important;
	margin-bottom: 15px;
`;
export const XThemeContainer = styled(Container)`
	padding: 0px 30px;
	@media only screen and (max-width: 768.99px) {
		padding: 0px 15px;
	}
	@media only screen and (min-width: 1920.99px) {
		width: 1800px;
	}
	@media only screen and (min-width: 2000.99px) {
		width: 100%;
	}
`;
export const XThemeCardFancy = styled(Card)`
	border-radius: 20px;
	border-style: solid;
	border-color: ${({ theme }) => theme.colors.themeColor22};
	border-width: 0px 0px 1px 1px;
	background: ${({ theme }) => theme.colors.white}
		url(../images/fancy-card-right.png) no-repeat right top;

	&.cardHeight {
		min-height: 350px;
		@media only screen and (max-width: 767px) {
			min-height: auto;
		}
	}
	.fancyCardInfo {
		position: absolute;
		text-align: center;
		top: 7px;
		right: 10px;
		width: 50px;
		height: 50px;
		line-height: 50px;
		border-radius: 50px;
		border: 1px solid ${({ theme }) => theme.colors.themeColor22};
		background: ${({ theme }) => theme.colors.white};
		@media only screen and (max-width: 767px) {
			right: 5px;
		}
		img {
			margin-top: -5px;
		}
	}
	&.cardLink {
		cursor: pointer;
	}
	.charTextNote {
		font-size: 10px;
		color: ${({ theme }) => theme.colors.themeColor4};
	}
	&.mobilePadding {
		@media only screen and (max-width: 767px) {
			border-right: 1px solid ${({ theme }) => theme.colors.bodyBg} !important;
			background-size: 55% 90%;
			.ant-card-body {
				padding: 20px;
			}
		}
	}
`;
export const XThemeButton = styled(Button)`
	width: 100%;
	border-radius: 50px !important;
	background: linear-gradient(
		90deg,
		${({ theme }) => theme.colors.themeColor8} 20.31%,
		${({ theme }) => theme.colors.themeColor25} 100%
	);
	color: ${({ theme }) => theme.colors.white};
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	padding: 8px 0px;
	height: auto;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: -0.28px;
	transition: background-color 0.4s ease, border-color 0.4s ease,
		color 0.4s ease;
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.white} !important;
	}
	&.backgroundRevers {
		background: ${({ theme }) => theme.colors.white};
		border-color: ${({ theme }) => theme.colors.themeColor8};
		color: ${({ theme }) => theme.colors.themeColor8};
		&:hover,
		&:focus {
			background: linear-gradient(
				90deg,
				${({ theme }) => theme.colors.themeColor8} 20.31%,
				${({ theme }) => theme.colors.themeColor25} 100%
			) !important;
			color: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.white} !important;
		}
	}
`;
export const XThemeGradientFilterBtn = styled(Button)`
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 25px;
	margin: 0px 5px;
	line-height: 16px;
	padding: 0px 15px;
	font-weight: 400;
	font-size: 12px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	&:hover,
	&.buttonActive {
		background: linear-gradient(
			90deg,
			#007299 20.31%,
			#7ee6e9 100%
		) !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
	}
	.defaultActive {
		background: gray !important;
		color: ${({ theme }) => theme.colors.themeColor22} !important;
		&:hover {
			background: ${({ theme }) => theme.colors.themeColor22} !important;
		}
	}
	@media only screen and (max-width: 991.99px) {
		font-size: 12px;
		line-height: 12px;
		padding: 10px 15px !important;
		height: auto;
	}
`;
export const XThemeGradientButton = styled(Button)`
	width: 100%;
	background: linear-gradient(
		90deg,
		${({ theme }) => theme.colors.themeColor8} 20.31%,
		${({ theme }) => theme.colors.themeColor25} 100%
	);
	border-radius: 10px;
	font-weight: 600;
	font-size: 20px;
	line-height: 30px;
	color: ${({ theme }) => theme.colors.white};
	height: auto;
	padding: 10px 0px;
	transition: 0.4s, background-position 0s;
	@media only screen and (max-width: 992px) {
		font-size: 20px;
		line-height: 30px;
	}
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
	}
	&.submitCancel {
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
	}
	&.backgroundRevers {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor8};
		color: ${({ theme }) => theme.colors.themeColor8};
		&:hover {
			background: linear-gradient(
				90deg,
				${({ theme }) => theme.colors.themeColor25} 20.31%,
				${({ theme }) => theme.colors.themeColor8} 100%
			) !important;
			color: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) =>
				theme.colors.themeColor13} !important;
		}
	}
`;
export const XThemeFilterCards = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 20px;
	border-style: solid;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};

	&.smallTopBottomPadding {
		.ant-card-body {
			padding-top: 10px;
			padding-bottom: 10px;
		}
	}
	h1.cardTitle {
		margin: 0px;
		font-weight: 600;
		font-size: 16px;
		line-height: 32px;
		letter-spacing: -0.02em;
		color: #212226;
	}
	span.info {
		background: #ffffff;
		border: 1px solid ${({ theme }) => theme.colors.themeColor8};
		border-radius: 5px;
		font-weight: 500;
		font-size: 14px;
		line-height: 28px;
		color: ${({ theme }) => theme.colors.themeColor8};
		padding: 3px 5px;
		margin-left: 7px;
	}
	&.noBackground {
		background: transparent;
		border: none;
		.ant-card-body {
			padding: 0px;
		}
	}
	&.noBGMobile {
		@media only screen and (max-width: 991.99px) {
			background: transparent;
			border: none;
			.ant-card-body {
				padding: 15px 0px;
			}
		}
	}
`;
export const XThemeFilterButton = styled(Button)`
	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor};
	height: auto !important;
	border-radius: 25px;
	padding: 12px 20px;
	font-weight: 500;
	font-size: 14px;
	line-height: 14px;
	text-align: center;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	transition: background-color 0.4s ease, border-color 0.4s ease,
		color 0.4s ease;
	&.backgroundRevers {
		/* background: ${({ theme }) => theme.colors.themeColor8}; */
		/* background: ${({ theme }) =>
			`linear-gradient(90deg, ${theme.colors.themeColor8} 20.31%, ${({
				theme,
			}) => theme.colors.themeColor25} 100%)`}; */
		background: ${({ theme }) => theme.CQColors.gradientBg};
		color: ${({ theme }) => theme.CQColors.white};
		border-color: ${({ theme }) => theme.CQColors.borderColor};
		&:hover,
		&:focus {
			background: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
			color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	&:hover,
	&:focus {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
	}
	svg {
		font-size: 16px;
	}
	&[disabled] {
		&:hover {
			background: ${({ theme }) => theme.CQColors.bodyBg} !important;
			color: ${({ theme }) => theme.CQColors.themeColor4} !important;
			border-color: ${({ theme }) => theme.CQColors.bodyBg} !important;
		}
	}
`;
export const XThemeFilterCircleButton = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	font-weight: 500;
	font-size: 14px;
	line-height: 14px;
	text-align: center;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.themeColor8};
	transition: background-color 0.4s ease, border-color 0.4s ease,
		color 0.4s ease;
	&:hover,
	&:focus {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: invert(1) brightness(2);
		}
	}
	&.backgroundRevers {
		background: ${({ theme }) => theme.colors.themeColor8};
		color: ${({ theme }) => theme.colors.white};
		border-color: ${({ theme }) => theme.colors.themeColor8};
		&:hover,
		&:focus,
		&:active {
			background: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
			color: ${({ theme }) => theme.colors.themeColor8} !important;
			img {
				filter: brightness(0) saturate(100%) invert(100%) sepia(91%)
					saturate(38%) hue-rotate(254deg) brightness(110%)
					contrast(110%);
			}
		}
		img {
			width: 80%;
			filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
				saturate(7452%) hue-rotate(309deg) brightness(98%) contrast(99%);
		}
	}

	&.grayBackground {
		background: ${({ theme }) => theme.colors.bodyBg};
		color: ${({ theme }) => theme.colors.themeColor8};
		border-color: ${({ theme }) => theme.colors.bodyBg};
		&:hover,
		&:focus,
		&:active {
			background: ${({ theme }) => theme.colors.themeColor8} !important;
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
			color: ${({ theme }) => theme.colors.white} !important;
			img {
				filter: brightness(0) saturate(100%) invert(100%) sepia(39%)
					saturate(0%) hue-rotate(148deg) brightness(109%)
					contrast(100%);
			}
		}
		img {
			width: 80%;
			filter: brightness(0) saturate(100%) invert(21%) sepia(55%)
				saturate(4154%) hue-rotate(178deg) brightness(99%)
				contrast(101%);
		}
	}
`;
export const XThemeTable = styled(Table)`
	position: relative;
	background: transparent;
	width: 100%;
	.ant-table {
		background: transparent;
		scrollbar-color: unset !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor22};
		border-radius: 15px;
	}
	/* .ant-table-pagination.ant-pagination {
		margin: 15px 0px 0px 0px;
	} */
	.ant-table-cell {
		font-style: normal;
		font-weight: 500 !important;
		font-size: 12px;
		line-height: 16px;
		text-transform: uppercase;
		background: ${({ theme }) => theme.colors.themeColor29} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		border-radius: 0px !important;
		a {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			text-decoration: underline;
		}
		&:first-child {
			border-radius: 15px 0px 0px 0px !important;
		}
		&:last-child {
			border-radius: 0px 15px 0px 0px !important;
		}
	}
	td.ant-table-cell {
		text-transform: capitalize;
		font-weight: 400 !important;
		font-size: 12px;
		background: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.themeColor5} !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		&:first-child {
			border-radius: 0px !important;
		}
		&:last-child {
			border-radius: 0px !important;
		}
	}
	tr {
		&:last-child {
			td.ant-table-cell {
				&:first-child {
					border-radius: 0px 0px 0px 15px !important;
				}
				&:last-child {
					border-radius: 0px 0px 15px 0px !important;
				}
			}
		}
	}
	.ant-table-fixed-column {
		.ant-table {
			border-radius: 15px 15px 0px 0px !important;
		}
		tr {
			&:last-child {
				td.ant-table-cell {
					&:first-child {
						border-radius: 5px !important;
					}
					&:last-child {
						border-radius: 5px !important;
					}
				}
			}
		}
	}
	ul.ant-pagination {
		margin: 15px 15px 0px 15px !important;
		.ant-pagination-jump-next,
		.ant-pagination-jump-prev {
			border-radius: 5px !important;
		}
		li.ant-pagination-item,
		.ant-pagination-jump-next,
		.ant-pagination-jump-prev,
		.ant-pagination-prev button,
		.ant-pagination-next button {
			/* background: ${({ theme }) => theme.colors.bodyBg}; */
			background: ${({ theme }) => theme.colors.white};
			color: ${({ theme }) => theme.colors.themeColor24};
			border-radius: 50%;
			font-weight: 600;
			font-size: 13px;
			.ant-pagination-item-ellipsis {
				font-size: 8px !important;
				color: ${({ theme }) =>
					theme.CQColors.secondaryColor} !important;
			}
			&:hover,
			&.ant-pagination-item-active {
				background: ${({ theme }) => theme.colors.themeColor8};
				color: ${({ theme }) => theme.colors.white} !important;
				border-color: ${({ theme }) => theme.colors.themeColor8};
				.ant-pagination-item-link-icon {
					color: ${({ theme }) => theme.colors.white} !important;
				}
			}
		}
		li.ant-pagination-disabled button {
			background: ${({ theme }) => theme.colors.themeColor22};
			color: ${({ theme }) => theme.colors.themeColor4};
			border-radius: 50%;
			font-weight: 600;
			font-size: 13px;
			&:hover {
				background: ${({ theme }) =>
					theme.colors.themeColor22} !important;
				color: ${({ theme }) => theme.colors.themeColor4} !important;
				border-color: ${({ theme }) => theme.colors.themeColor22};
			}
		}
	}
	/* Table triangle Status */
	.showDate img {
		margin-right: 10px;
		margin-top: -3px;
	}
	td.custom-border-left {
		// border-left: 10px solid green !important;
		// border-radius: 20px !important;
		padding: 0 !important;
	}
	td > .claim_category_line {
		height: 70px !important;
		display: grid;
		place-items: center;
	}
	td > .full {
		border-left: 2px solid #00a954 !important;
	}
	td > .neutral {
		border-left: 2px solid #e9ecef !important;
	}
	td > .rejected {
		border-left: 2px solid #ff1c1c !important;
	}
	td > .partial {
		border-left: 2px solid #ffd17b !important;
	}
	td > .triangle {
		// width: 0;
		// height: 0;
		display: grid;
		place-items: center;
		position: absolute;
		top: 0;
	}
	td > .in_process {
		border-right: 20px solid transparent;
		border-top: 20px solid #1f9254 !important;
	}
	td > .untimely {
		border-right: 20px solid transparent;
		border-top: 20px solid #db3a17 !important;
	}
	td > .escalation {
		border-right: 20px solid transparent;
		border-top: 20px solid #e57711 !important;
	}
	td > .at_risk {
		border-right: 20px solid transparent;
		border-top: 20px solid #e5aa11 !important;
	}

	// select checkbox in table
	.ant-checkbox-inner {
		border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		background: #e6f3ff !important;
	}
	.ant-checkbox-inner {
		&:after {
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	.ant-checkbox-indeterminate {
		.ant-checkbox-inner {
			&:after {
				background: ${({ theme }) =>
					theme.colors.themeColor8} !important;
			}
		}
	}
	th.ant-table-selection-column,
	td.ant-table-selection-column {
		padding-left: 20px !important;
	}
`;
export const XThemeForm = styled(Form)`
	.drawerlabel .ant-form-item-label label,
	.drawerlabel label {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		color: ${({ theme }) => theme.CQColors.primaryColor} !important;
		font-weight: 400 !important;
		font-size: 14px !important;
		font-style: normal !important;
	}
	.drawerlabelBold .ant-form-item-label > label,
	.drawerlabelBold label {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		color: ${({ theme }) => theme.CQColors.primaryColor} !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		font-style: normal !important;
	}
	h1.XThemeModalTitle {
		margin: 0px;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 28px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	.textAreaStyle {
		textarea {
			width: 100%;
			position: relative;
			background: ${({ theme }) => theme.colors.white} !important;
			border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
			border-radius: 10px !important;
			font-weight: 400 !important;
			font-size: 16px !important;
			line-height: 22px !important;
			color: ${({ theme }) => theme.colors.themeColor2} !important;
		}
	}
	.textAreaStyleDarkBorder {
		.ant-input-affix-wrapper {
			border: none !important;
		}
		textarea {
			width: 100%;
			position: relative;
			background: ${({ theme }) => theme.colors.white} !important;
			border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
			border-radius: 10px !important;
			font-weight: 400 !important;
			font-size: 16px !important;
			line-height: 22px !important;
			color: ${({ theme }) => theme.colors.themeColor2} !important;
		}
	}
	.customSelectWithIcon {
		display: flex;
		align-items: center;
		position: relative;
	}
	.customSelectedIcon {
		position: absolute;
		left: 10px;
		z-index: 1;
		width: 15px;
		height: 15px;
		pointer-events: none;
	}

	/* input {
		border: 1px solid ${({ theme }) => theme.colors.color3};
		background: transparent;
		height: auto;
		padding-top: 10px;
		padding-bottom: 10px;
		@media only screen and (max-width: 768px) {
		}
	}
	button {
		display: inline-block;
		margin-left: 15px;
		border-radius: 20px;
		background: ${({ theme }) => theme.colors.menu2};
		color: #fff;
		font-size: 14px !important;
		padding: 10px 30px;
		height: auto;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		border: 1px solid ${({ theme }) => theme.colors.color6};
		&:hover {
			background: ${({ theme }) => theme.colors.menu2};
			color: #fff;
		}
		@media only screen and (max-width: 768.99px) {
		}
	}
	.ant-upload-list-item-action.ant-btn {
		background: none;
	}
	button.cancel {
		background: ${({ theme }) => theme.colors.white};
		color: #171c26;
	}
	.customLabel {
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 28px;
	}
	.customHeader {
		color: ${({ theme }) => theme.colors.menu2};
		background: #f3f6f9;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 28px;
		padding: 5px 15px;
	}
	.ant-switch {
		padding: 0px 5px;
		background: transparent;
		border: 1px solid ${({ theme }) => theme.colors.menu2};

		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.menu2};
			}
		}
	}
	button.ant-switch {
		&:hover {
			background: ${({ theme }) => theme.colors.menu2};
			.ant-switch-handle {
				&::before {
					background: ${({ theme }) => theme.colors.white};
				}
			}
		}
	}
	button.ant-switch-checked {
		background: ${({ theme }) => theme.colors.menu2};
		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.white};
			}
		}
	}
	.ant-picker-large .ant-picker-input > input {
		font-size: 14px !important;
	} */
`;
export const XThemeRadio = styled(Radio)`
	margin-top: 10px;
	color: ${({ theme }) => theme.colors.primaryColor};
	font-weight: 400;
	font-size: 12px !important;
	line-height: 16px !important;
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		border-color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	&.ant-radio-wrapper-checked {
		span {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
	/* .ant-radio-disabled .ant-radio-inner {
		background-color: #f5f5f5;
		border-color: #d9d9d9;
	}
	.ant-radio-disabled .ant-radio-inner:after {
		background-color: #bfbfbf;
	}
	.ant-radio-disabled span {
		color: #8c8c8c;
	} */
`;
export const XRadioButton = styled(Radio)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white} !important;
	border-radius: 10px !important;
	border: 1px solid rgba(18, 18, 73, 0.15);
	padding: 15px;
	margin-bottom: 7px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	font-weight: 400;
	font-size: 14px !important;
	line-height: 14px !important;
	&:last-child {
		margin-bottom: 0px;
	}
	span.ant-radio + * {
		padding-left: 10px !important;
	}
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: #007299;
		border-color: #007299;
	}
`;
export const XThemeSelect = styled(Select)`
	width: 100%;
	.ant-select-selector {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
		border-radius: 25px !important;
		font-weight: 400 !important;
		font-size: 13px !important;
		line-height: 16px !important;
		color: ${({ theme }) => theme.colors.themeColor2} !important;
	}
	&.noBorderRadius {
		.ant-select-selector {
			border-radius: 10px !important;
		}
	}
	&.largeInputForms {
		/* &.{
			.ant-select-selector {
				padding-left: 15px !important;
			}
		} */
		.ant-select-selector {
			height: 44px !important;
			border-radius: 10px !important;
			line-height: 44px !important;
			font-size: 16px !important;
			border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
			/* padding-left: 30px !important; */
		}
		/* .ant-select-selection-overflow + span.ant-select-selection-placeholder {
			margin-top: -1px;
			height: 44px !important;
			line-height: 44px !important;
			font-size: 16px !important;
			padding-left: 20px !important;
		} */
	}
`;
export const XThemeDrawer = styled(Drawer)`
	width: 100%;
	.ant-drawer-title {
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		font-size: 16px;
		line-height: 16px;
		font-weight: 600;
	}
	::-webkit-scrollbar {
		width: 2px;
		height: 2px;
		background: #f4f3f3;
	}
	::-webkit-scrollbar-thumb {
		background: #9b9b9b;
	}
	::-webkit-scrollbar {
		width: 3px;
		height: 3px;
		background: #f4f3f3;
	}
	::-webkit-scrollbar-thumb {
		background: #9b9b9b;
	}
`;
export const XThemeTag = styled(Tag)`
	border-radius: 10px;
	font-family: ${({ theme }) => theme.colors.fontPoppins} !important;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.36px;
	padding-left: 20px;
	padding-right: 10px;
	border: none;
	&:before {
		content: '\u{25CF}';
		position: absolute;
		top: 0px;
		left: 10px;
		font-size: 10px;
	}
	&.staticTag {
		position: absolute;
		top: 30%;
		left: 30%;
		padding: 0px 10px !important;
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		color: ${({ theme }) => theme.colors.themeColor5} !important;
		&:before {
			display: none !important;
			content: '' !important;
		}
	}
`;
export const XThemeInputText = styled(Input)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white} !important;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
	border-radius: 25px !important;
	font-weight: 400 !important;
	font-size: 13px !important;
	line-height: 22px !important;
	color: ${({ theme }) => theme.colors.themeColor2} !important;
	&.noBorderRadius {
		border-radius: 10px !important;
	}
	&.largeInputForms {
		background: ${({ theme }) => theme.colors.white} !important;
		border-radius: 10px !important;
		line-height: 28px !important;
		font-size: 16px !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
	}

	&:hover,
	&:focus {
	}
`;
export const XThemeDatePicker = styled(DatePicker)`
	width: 100%;
	position: relative;
	&.largeInputForms {
		border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
		border-radius: 10px !important;
		height: 44px !important;
		.ant-picker-input > input {
			line-height: 28px !important;
			font-size: 16px !important;
			color: ${({ theme }) => theme.colors.themeColor2} !important;
		}
	}

	&:hover,
	&:focus {
	}
`;
export const XThemeUploadButton = styled(Button)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white} !important;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	font-size: 14px !important;
	line-height: 22px !important;
	color: ${({ theme }) => theme.colors.themeColor2} !important;
	height: auto !important;
	box-shadow: none !important;
	padding: 15px;

	&:hover,
	&:focus {
	}
`;
export const XThemeSwitchBtn = styled(Switch)`
	&.ant-switch-checked {
		background-color: ${({ theme }) =>
			theme.CQColors.secondaryColor}!important;
		border: none !important;
	}
	&:not(.ant-switch-checked) {
		background-color: ${({ theme }) =>
			theme.colors.themeColor23} !important;
		border: none !important;

		.ant-switch-handle::before {
			background-color: #fff !important;
		}
	}
	.ant-switch-inner .ant-switch-inner-unchecked {
		color: black !important;
	}
`;
export const XCustomTabsFilter = styled(Tabs)`
	.ant-tabs {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	}
	.ant-tabs-nav::before {
		display: none;
	}
	.ant-tabs-content-holder {
		@media only screen and (max-width: 768px) {
		}
	}
	.ant-tabs-tab {
		border-radius: 15px !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor}!important;
		background: ${({ theme }) => theme.CQColors.white} !important;
		padding: 10px 20px;
		margin-right: 10px !important;
		span {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			font-weight: 500 !important;
		}
		&:hover {
			background: ${({ theme }) => theme.CQColors.gradientBg} !important;
			color: ${({ theme }) => theme.CQColors.white} !important;
			.ant-tabs-tab-btn,
			span {
				color: ${({ theme }) => theme.CQColors.white} !important;
			}
		}
		.ant-tabs-tab-btn {
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: -0.02em;
			// color: ${({ theme }) => theme.colors.themeColor8};
		}
		.ant-tag {
			margin-left: 10px !important;
			margin-right: 0px !important;
			background: #e1edf2;
			border-radius: 10px;
			border: transparent;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
		}
	}
	.ant-tabs-tab-active {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		.ant-tabs-tab-btn {
			color: #fff !important;
		}
		&:hover {
			.ant-tabs-tab-btn {
				color: #fff !important;
			}
		}
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XEditButtonIcon = styled(Button)`
	border: none !important;
	&:disabled {
		background: transparent !important;
		border: none !important;
		font-size: 20px;
		opacity: 0.4 !important;
	}
	&:hover:not(:disabled) {
		background: transparent !important;
		border: none !important;
		color: ${({ theme }) => theme.colors.themeColor8} !important;
	}
	svg,
	img {
		margin-top: -2px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		filter: ${({ theme }) => theme.CQColors.imgFilterColor};
	}
	&:hover {
		border: none !important;
		background: transparent !important;
	}
	&.hasIconColor {
		background: transparent;
		border: none !important;
		box-shadow: none !important;
		font-size: 20px;
		svg,
		img {
			color: ${({ theme }) => theme.CQColors.secondaryColor};
			filter: ${({ theme }) => theme.CQColors.imgFilterColor};
		}
	}
`;
export const XThemeModal = styled(Modal)`
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;

	.ant-modal-title {
		/* font-family: ${({ theme }) =>
			theme.CQColors.fontInter} !important; */
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		font-size: 16px !important;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 20px;
	}
	label {
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		font-size: 14px !important;
		font-weight: 500 !important;
	}
	p.modalPara1 {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	}
	.modalButton {
		width: 100%;
		position: relative;
		margin: 0px;
		display: block;
		color: ${({ theme }) => theme.colors.white};
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.36px;
	}
	.ant-modal-content {
		border-radius: 20px !important;
	}
	.ant-modal-footer {
		.ant-btn {
			border-radius: 20px;
			height: 40px;
			padding: 0px 30px;
			font-size: 14px;
			font-style: normal;
			font-weight: 500;
			line-height: 20px;
			letter-spacing: 0.28px;
		}
		.ant-btn-primary {
			border: 1px solid ${({ theme }) => theme.colors.color6};
			background: ${({ theme }) => theme.colors.menu2};
			&:hover {
				border: 1px solid ${({ theme }) => theme.colors.color6};
				background: ${({ theme }) => theme.colors.menu2};
			}
		}
		.ant-btn-default {
			border-color: ${({ theme }) => theme.colors.color6};
			background: ${({ theme }) => theme.colors.white};
			box-shadow: 0px 0px 0px 1px rgba(70, 79, 96, 0.32),
				0px 5px 5px 0px rgba(0, 0, 0, 0.1);
			color: ${({ theme }) => theme.colors.menu2};
			&:hover {
				border-color: ${({ theme }) => theme.colors.menu2};
				background: ${({ theme }) => theme.colors.menu2};
				color: ${({ theme }) => theme.colors.white};
			}
		}
	}
`;
export const XThemeModalScroll = styled(Card)`
	width: 100%;
	position: relative;
	overflow-x: hidden;
	overflow-y: scroll;
	max-height: 300px;
	border: none;
	&::-webkit-scrollbar {
		width: 2px;
		height: 2px;
		background: #f4f3f3;
	}
	&::-webkit-scrollbar-thumb {
		background: #9b9b9b;
	}
	&::-webkit-scrollbar {
		width: 3px;
		height: 3px;
		background: #f4f3f3;
	}
	&::-webkit-scrollbar-thumb {
		background: #9b9b9b;
	}
	.ant-card-body {
		padding: 10px 15px;
	}
	.allCheckTitle {
		margin: 0px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		background: ${({ theme }) => theme.colors.bodyBg};
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		padding: 10px 15px;
		margin: 0px -10px 0px -15px;
	}
`;
export const XThemeTag2 = styled(Tag)`
	background: ${({ theme }) => theme.colors.themeColor22};
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	font-family: ${({ theme }) => theme.colors.fontInter} !important;
	border-radius: 15px;
	font-size: 11px;
	line-height: 11px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.36px;
	margin: 0px 3px 3px 0px;
	padding: 5px 10px;
	border: none;
`;
export const XThemeCustomTabsTable = styled(Tabs)`
	.ant-tabs {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	}
	.ant-tabs-nav::before {
		display: none;
	}
	.ant-tabs-nav {
		background: rgba(255, 255, 255, 0.5);
		border: 1px solid rgba(208, 224, 223, 0.5);
		border-radius: 10px;
	}
	.ant-tabs-tab:hover .ant-tabs-tab-btn {
		color: ${({ theme }) => theme.colors.themeColor8} !important;
	}
	.ant-tabs-tab {
		background: transparent !important;
		border: 0px !important;
		margin: 5px !important;
		&:hover {
			background: transparent !important;
			color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
		.ant-tabs-tab-btn {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			background: transparent !important;
			border-radius: 0px !important;
			box-shadow: none !important;
			border: none !important;
			padding: 0px !important;
			font-weight: 400 !important;
			font-size: 14px !important;
			line-height: 20px !important;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
			&:hover {
				color: ${({ theme }) => theme.colors.themeColor8} !important;
			}
		}
		.ant-tag {
			margin-left: 10px !important;
			margin-right: 0px !important;
			background: #e1edf2;
			border-radius: 10px;
			border: transparent;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
		}
	}
	.ant-tabs-tab-active {
		background: ${({ theme }) => theme.colors.white} !important;
		box-shadow: 0px 0px 10px rgba(0, 114, 153, 0.15) !important;
		border-radius: 10px !important;
		/* border-right: none !important; */
		.ant-tabs-tab-btn {
			color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	/* Table triangle Status */
	.showDate img {
		margin-right: 10px;
		margin-top: -3px;
	}
	td.custom-border-left {
		// border-left: 10px solid green !important;
		// border-radius: 20px !important;
		padding: 0 !important;
	}
	td > .claim_category_line {
		height: 70px !important;
		display: grid;
		place-items: center;
	}
	td > .full {
		border-left: 5px solid #00a954 !important;
	}
	td > .neutral {
		border-left: 5px solid #e9ecef !important;
	}
	td > .rejected {
		border-left: 5px solid #ff1c1c !important;
	}
	td > .partial {
		border-left: 5px solid #ffd17b !important;
	}
	td > .triangle {
		// width: 0;
		// height: 0;
		display: grid;
		place-items: center;
		position: absolute;
		top: 0;
	}
	td > .in_process {
		border-right: 20px solid transparent;
		border-top: 20px solid #1f9254 !important;
	}
	td > .untimely {
		border-right: 20px solid transparent;
		border-top: 20px solid #db3a17 !important;
	}
	td > .escalation {
		border-right: 20px solid transparent;
		border-top: 20px solid #e57711 !important;
	}
	td > .at_risk {
		border-right: 20px solid transparent;
		border-top: 20px solid #e5aa11 !important;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeAffixCard = styled(Card)`
	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 10px !important;
		}
	}
`;
export const XThemeDetailsCards = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 15px;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	&.largePadding {
		.ant-card-body {
			padding: 40px;
			@media only screen and (max-width: 993px) {
				padding: 30px 15px;
			}
		}
	}
	.borderRightOnly {
		width: 100%;
		position: relative;
		height: 100%;
		padding-right: 24%;
		&::after {
			position: absolute;
			border-right: 1px dotted ${({ theme }) => theme.colors.themeColor22};
			/* border-right: 1px solid green; */
			right: 12%;
			top: -40px;
			bottom: -40px;
			content: '';
			display: block;
			width: 1px;
			height: calc(100% + 80px);
		}
		@media only screen and (max-width: 768.99px) {
			padding-right: 0% !important;
			span {
				border: none !important;
				background: transparent !important;
			}
			&::after {
				border: none !important;
			}
		}
	}
	&.background {
		background: ${({ theme }) => theme.colors.bodyBg};
	}
	&.noBGMobile {
		@media only screen and (max-width: 991.99px) {
			background: transparent;
			border: none;
			.ant-card-body {
				padding: 15px 0px;
			}
		}
	}
`;
export const XThemeUploadProfile = styled(Upload)`
	width: 100%;
	position: relative;
	background: #f0f5f8;
	color: #169191;
	border: 1px dashed rgba(33, 34, 38, 0.2);
	border-radius: 10px;
	min-height: 250px;
	.ant-upload-list-item-container {
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 150px !important;
		height: 150px !important;
		margin-right: 0px !important;
		.ant-upload-list-item-thumbnail {
			object-fit: none !important;
			height: auto !important;
		}
	}
	.ant-upload-select {
		position: absolute;
		width: auto !important;
		bottom: -3%;
		left: 50%;
		height: auto !important;
		transform: translate(-50%, -50%);
		border-radius: 10px !important;
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid rgba(0, 114, 153, 0.2) !important;
		border-radius: 10px !important;
		padding: 8px 15px !important;
		font-weight: 600 !important;
		font-size: 14px !important;
		color: ${({ theme }) => theme.colors.themeColor8};
	}
`;
export const XThemeCustomSteps = styled(Steps)`
	display: inline !important;
	.ant-steps-item-title {
		&::after {
			display: none !important;
		}
	}
	.ant-steps-item-icon {
		background: #e8f3f6 !important;
		font-weight: 500;
		font-size: 14px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		border-color: ${({ theme }) => theme.CQColors.white};
	}
	.ant-steps-item-title {
		font-weight: 400;
		font-size: 14px;
		color: ${({ theme }) => theme.CQColors.themeColor4};
	}
	.ant-steps-item-active {
		.ant-steps-item-icon {
			background: ${({ theme }) => theme.CQColors.gradientBg} !important;
			border-color: ${({ theme }) => theme.CQColors.white};
		}
	}
	.ant-steps-item-active {
		.ant-steps-item-title {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
	@media only screen and (max-width: 991.99px) {
		display: flex !important;
		.ant-steps-item-title {
			span {
				display: none !important;
			}
			&::after {
				display: block !important;
				background-color: #e8f3f6 !important;
				inset-inline-start: 0px !important;
			}
		}
		.ant-steps-item-icon {
			margin-inline-end: 0px !important;
			background-color: ${({ theme }) => theme.CQColors.white} !important;
			border-color: ${({ theme }) => theme.CQColors.white} !important;
			span {
				color: ${({ theme }) => theme.colors.themeColor8} !important;
			}
		}
		.ant-steps-item-active {
			.ant-steps-item-icon {
				background: ${({ theme }) =>
					theme.CQColors.secondaryColor} !important;
				border-color: ${({ theme }) => theme.CQColors.white} !important;
				span {
					color: ${({ theme }) => theme.CQColors.white} !important;
				}
			}
		}
		.ant-steps-item-title::after {
			background-color: ${({ theme }) =>
				theme.CQColors.secondaryColor} !important;
		}
		.ant-steps-item {
			padding-inline-start: 0px !important;
		}
	}
	@media only screen and (max-width: 991.99px) {
		display: flex !important;
		.ant-steps-item-title {
			span {
				display: none !important;
			}
			&::after {
				display: block !important;
				background-color: ${({ theme }) =>
					theme.CQColors.secondaryColor} !important;
				inset-inline-start: 0px !important;
			}
		}
		.ant-steps-item-icon {
			margin-inline-end: 0px !important;
			background-color: ${({ theme }) => theme.CQColors.white} !important;
			border-color: ${({ theme }) => theme.CQColors.white} !important;
			span {
				color: ${({ theme }) => theme.colors.themeColor8} !important;
			}
		}
		.ant-steps-item-active {
			.ant-steps-item-icon {
				background: ${({ theme }) =>
					theme.CQColors.gradientBg} !important;
				border-color: ${({ theme }) => theme.CQColors.white} !important;
				span {
					color: ${({ theme }) => theme.CQColors.white} !important;
				}
			}
		}
		.ant-steps-item-title::after {
			background-color: ${({ theme }) =>
				theme.CQColors.secondaryColor} !important;
		}
		.ant-steps-item {
			padding-inline-start: 0px !important;
		}
	}
`;
export const XThemeNextPrevBtn = styled(Button)`
	background: linear-gradient(
		90deg,
		${({ theme }) => theme.colors.themeColor8} 20.31%,
		${({ theme }) => theme.colors.themeColor25} 100%
	);
	color: ${({ theme }) => theme.colors.white};
	border-color: ${({ theme }) => theme.colors.white};
	border: none;
	border-radius: 20px;
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	letter-spacing: 0.02em;
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		color: ${({ theme }) => theme.colors.white} !important;
	}
	svg {
		font-size: 16px !important;
	}

	/* border-radius: 50px !important;
	background: #007299 !important;
	color: ${({ theme }) => theme.colors.white};
	font-family: ${({ theme }) => theme.colors.fontDM};
	padding: 10px 0px;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px;
	letter-spacing: -0.28px;
	span {
		display: masonry !important;
	}
	&:hover {
		background: #007299 !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: #007299 !important;
	}
	svg {
		margin-top: -4px;
	}
	@media only screen and (max-width: 576.99px) {
		margin: 5px !important;
	} */
`;
export const XThemeFormsTitle = styled.h6`
	font-style: normal;
	font-weight: 600;
	font-size: 17px;
	line-height: 26px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	padding-bottom: 15px;
	margin: 0px 0px 20px 0px;
	border-bottom: 1px dashed ${({ theme }) => theme.colors.themeColor23};
`;
export const XThemeTagsDate = styled(Tag)`
	background: ${({ theme }) => theme.colors.bodyBg};
	border: 1px solid ${({ theme }) => theme.colors.themeColor8};
	color: ${({ theme }) => theme.colors.themeColor8} !important;
	padding: 10px 15px !important;
	font-weight: 400;
	font-size: 16px;
	line-height: 22px;
	border-radius: 20px;
	.anticon-close {
		padding: 3px !important;
		font-size: 10px;
		background: ${({ theme }) => theme.colors.themeColor8};
		color: ${({ theme }) => theme.colors.white};
		border-radius: 15px;
		margin-left: 30px;
		&:hover {
			color: ${({ theme }) => theme.colors.white};
		}
	}
	@media only screen and (max-width: 767.99px) {
	}
`;
export const XThemeUploadWithDragger = styled(Dragger)`
	width: 100%;
	position: relative;
	.ant-upload-drag {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px dashed ${({ theme }) => theme.colors.themeColor23};
		padding: 30px 15px !important;
	}
	svg {
		font-size: 26px;
		margin-right: 10px;
	}
	/* width: 100%;
	position: relative;
	display: block;
	cursor: pointer;
	background: ${({ theme }) => theme.colors.white};
	border: 1px dashed ${({ theme }) => theme.colors.themeColor23};
	border-radius: 10px;
	padding: 40px 15px !important;
	.ant-upload-select {
		display: block !important;
	}
	.ant-space-item {
		font-weight: 400;
		font-size: 16px;
		line-height: 26px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	.custonBtn {
		background: rgba(0, 114, 153, 0.1);
		border: 1px solid rgba(0, 114, 153, 0.2);
		border-radius: 25px;
		font-weight: 400;
		font-size: 16px;
		line-height: 16px;
		color: ${({ theme }) => theme.colors.themeColor8};
		padding: 5px 15px;
	}
	svg {
		font-size: 26px;
		margin-right: 10px;
	} */
`;
export const XThemeViewUploadedDocs = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor23};
	border-radius: 10px;
	font-weight: 500;
	font-size: 14px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	.ant-card-body {
		padding: 10px;
	}
	img {
		margin-right: 5px;
		background: ${({ theme }) => theme.colors.bodyBg};
		border-radius: 50%;
		padding: 10px;
	}
	@media only screen and (max-width: 767.99px) {
	}
`;
export const XThemeUploadWithCard = styled(Card)`
	width: 100%;
	position: relative;
	display: block;
	cursor: pointer;
	background: #f0f5f8;
	border: 1px dashed rgba(33, 34, 38, 0.2);
	border-radius: 10px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	.ant-card-body {
		padding: 10px !important;
	}
	.ant-space-item {
		font-size: 16px !important;
		font-weight: 400;
		line-height: 26px;
	}
	.custonBtn {
		background: rgba(0, 114, 153, 0.1);
		border: 1px solid rgba(0, 114, 153, 0.2);
		border-radius: 25px;
		font-weight: 400;
		font-size: 16px;
		line-height: 16px;
		color: ${({ theme }) => theme.colors.themeColor8};
		padding: 5px 15px;
	}
	svg {
		font-size: 26px;
		margin-right: 10px;
	}
`;
export const XThemeLogsCards = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 10px;
	border-style: solid;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	h6.heading {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		margin: 0px 0px 2px 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 21px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		word-wrap: break-word;
	}
	h4.headingTile {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		margin: 0px;
		font-weight: 500;
		font-size: 15px;
		line-height: 20px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		word-wrap: break-word;
	}
`;
export const XThemeLogsTags = styled(Tag)`
	&.info {
		background: #fdf3e5;
		border: none;
		color: #e78900 !important;
		font-weight: 500 !important;
		font-size: 13px !important;
		line-height: 24px;
	}
	&.default {
		background: #e5f1f5;
		border: none;
		color: ${({ theme }) => theme.colors.themeColor8} !important;
		font-weight: 500 !important;
		font-size: 13px !important;
		line-height: 24px;
	}
	&.warning {
		background: #fbe5e8;
		border: none;
		color: ${({ theme }) => theme.colors.themeColor14} !important;
		font-weight: 500 !important;
		font-size: 13px !important;
		line-height: 24px;
	}
	@media only screen and (max-width: 767.99px) {
	}
`;
export const XThemeNotifications = styled.div`
	max-height: 340px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 0.2em;
	}
	&::-webkit-scrollbar,
	&::-webkit-scrollbar-thumb {
		overflow: visible;
		border-radius: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.2);
	}
	.loaderSpin {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 340px;
		width: 100%;
		text-align: center;
		position: absolute;
		top: 0px;
		left: 0px;
	}
	.notifTitle {
		font-size: 14px;
		line-height: 18px;
	}
	.notifTime {
		font-size: 12px;
		padding-bottom: 10px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		border-bottom: 1px dashed ${({ theme }) => theme.colors.themeColor23};
		display: flex;
		align-items: center;
		svg {
			font-size: 14px;
			line-height: 24px;
			margin-right: 6px;
			margin-left: 4px;
		}
	}
	.notifSummary {
		margin-top: 5px;
		p {
			margin: 0px 10px;
			font-size: 12px;
			line-height: 16px;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
		}
	}
`;
/***** Mobile version *******/
export const XThemeTableMobileCard = styled(Card)`
	background: transparent;
	border-radius: 20px;
	border: none;
	padding: 10px;
	.ant-card-body {
		border-radius: 20px;
		background: ${({ theme }) => theme.colors.white};
		box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
		padding: 30px !important;
		@media only screen and (max-width: 768.99px) {
			padding: 0 !important;
			box-shadow: none !important	;
		}
	}
`;
export const GlobalStyle = createGlobalStyle`
	*{
		/* margin: 0;
		padding: 0;
		box-sizing: border-box;*/
		/* /* font-family: ${({ theme }) => theme.CQColors.fontInter} !important;  */ */
	}
	/* h1, h2, h3, h4, h5, h6, p, a{
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	} */
	/* body{
		background: ${({ theme }) => theme.colors.white} !important;
        margin: 0px;
        padding:0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		&.bodyImageNoBgColor{
		width:100%;
		position: relative;
		background: transparent url(../images/body-bg.svg) no-repeat center center !important;
		background-size: cover !important;
		min-height:100vh;
		}		
		&.bodyOverflowHideImageBg {
			width:100%;
			position: relative;
			background: transparent url(../images/body-bg.svg) no-repeat center center !important;
			background-size: cover !important;
			height:100vh;
			overflow: hidden;
			@media only screen and (max-width: 992px) {
				overflow: auto;
				height:100%;
				background: ${({ theme }) => theme.colors.bodyBg} !important;
			}
		}
	} */
    .custom-crop-modal .ant-btn-default {
        color: #007299; /* Reset button text color */
        background:#fff;
        border-radius: 20px; /* Reset button rounded corners */
        padding: 6px 16px; /* Reset button padding */
        margin-right: 8px; /* Optional: spacing */
    }
	.ant-layout-has-sider, .ant-layout{
		background:transparent !important;
	}
	a, p{
		font-family:${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight:normal;
		text-decoration:none;
	}
    .logo{
		display:block;
		width: 100%;
		text-align: left;
		padding: 17.5px 17px;
        border-bottom: 1px solid ${({ theme }) => theme.colors.themeColor22};
		margin-bottom: 10px;
		@media (max-width: 992px) {
			margin:0px;
		}
	}
	.logo a img{
		vertical-align: middle;
		border-style: none;
	}    
	.ant-menu-item {
		margin: 15px auto !important;
		padding-left: 20px !important; 
	}
	// .nav-link-item {
	// 	display: block;
	// 	text-align: center;
    //     background: ${({ theme }) => theme.colors.white};
    //     width:35px;
    //     height:35px;
	// 	border-radius: 50%;
    //     border:1px solid  ${({ theme }) => theme.colors.white};
    //     &:hover{
    //         border-color:${({ theme }) => theme.colors.themeColor22};
    //     }
	// }
	// .nav-link-item-active{
	// 	display: block;
	// 	text-align: center;
	// 	background: ${({ theme }) => theme.colors.themeColor8};
    //     border:1px solid  ${({ theme }) => theme.colors.themeColor8};
    //     width:35px;
    //     height:35px;
	// 	border-radius: 50%;
	// }
	
	.ant-menu-title-content, 
	.ant-menu-submenu-arrow{
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		font-size: 12px !important;
		font-weight: 500 !important;
		span.newBadge{
			background: linear-gradient(270deg, rgba(22, 145, 145, 0.7) 0%, rgba(130, 196, 70, 0.7) 100%);
			border-radius: 35.7143px;
			color: #fff;
			padding: 4px 7px;
			font-size: 10px;
			margin: 0px 0px 0px 5px;
		}
		span.sidebarTitle{			
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
			letter-spacing: 1px;
			text-transform: uppercase;
			color: #A1A1AA;
		}
	}
	.ant-menu-item{	
		margin: 5px auto !important;
		&.ant-menu-item-disabled{
			margin: 15px auto 0px auto !important;
		}
		.ant-menu-title-content, a{
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			font-size: 12px !important;
			font-weight: 500 !important;
		}

		&.ant-menu-item-selected, 
		&.ant-menu-item-active{
			.ant-menu-title-content, a{
				color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			}
			img{
				filter: brightness(0) saturate(100%) invert(42%) sepia(15%) saturate(5474%) hue-rotate(147deg) brightness(91%) contrast(83%);
			}
		}
		img{
			filter: brightness(0) saturate(100%) invert(8%) sepia(10%) saturate(2867%) hue-rotate(182deg) brightness(95%) contrast(96%);
		}
	}

	.ant-menu-submenu-title{
		padding-left: 15px !important;
		
	}
	.ant-menu-submenu-title a{
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		font-size: 12px !important;
		font-weight: 500 !important;
	}

	.sidebarFooter{
		position: relative;
		width: 100%;
		background: transparent;
		border-top: 1px solid ${({ theme }) => theme.colors.themeColor22};
		
	}

	.offcanvas-header{
		border-bottom:1px solid #CCC;
	}
	.offcanvas.offcanvas-top{
		height:100vh;
		transition:transform 0.3s ease-in-out !important;
		z-index:1050;
		@media only screen and (max-width: 1199.99px) {
			padding-top:60px;
		}
	}
    .ant-layout-sider-children, .ant-menu-light {
		background: transparent;
	}
	.headerTagDashboard{
		color: #212226;
		font-family: Poppins;
		font-size: 18px;
		font-style: normal;
		font-weight: 500;
		line-height: 32px; /* 177.778% */
		letter-spacing: -0.36px;
	}
	h1.fancyCardTitle {
		margin: 0px;
		font-weight: 500;
		font-size: 18px;
		line-height: 16px;
		color: ${({ theme }) => theme.colors.themeColor2};
		@media only screen and (max-width: 991.99px) {
			font-size: 16px;
			font-weight: 600;
		}
	}
	.donut-amount {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		font-weight: 600;
		font-size: 22px;
		line-height: 26px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor8};
		z-index: 1;
		@media only screen and (max-width: 768px) {
			font-size: 18px;
			line-height: 22px;
		}
		span{
			font-weight: 400;
			font-size: 14px;
			line-height: 22px;
			color: ${({ theme }) => theme.colors.themeColor4};
			@media only screen and (max-width: 768px) {
				font-size: 12px;
				line-height: 20px;
			}
		}
	}
	.donut-chart{			
		.custom-legend{
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.legend-item{	
				width:100%;	
				margin-top: 10px;
				text-align: left;
				@media only screen and (max-width: 768px) {
					margin-top: 5px;
					padding-left: 15px;
				} 
				&:first-child{
					margin-top: 0px;
				}
				.legend-color {
					border-radius: 50%;
					width: 12px !important;
					height: 12px !important;
					display: inline-block !important;
					margin-right: 5px !important;
				}
				.legend-text {					
					font-weight: 500;
					font-size: 13px;
					line-height: 16px;
					letter-spacing: -0.02em;
					color: ${({ theme }) => theme.colors.themeColor2};
					@media only screen and (max-width: 768px) {
						font-size: 10px;
						line-height: 12px;
					} 
				}
			}
		}
	}
	.half-donut-chart{
		width: 100% !important;
		height: 230px !important;
		@media only screen and (max-width: 768px) {
			
		}	
		.custom-legend{
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			@media only screen and (max-width: 991.99px) {	
				width:100%;		
				position:relative ;
				display: block;
				align-items: center;
				text-align: center;
			}
			.legend-item{	
				width:100%;	
				padding-left:40px;
				margin-top: 10px;
				@media only screen and (max-width: 991.99px) {
					width: auto;
					padding-left:0px;
					margin-right: 10px;
					display: inline-flex;
					&:last-child{
						margin-right: 0px;
					}
				}
				&:first-child{
					margin-top: 0px;
				}
				.legend-color {
					border-radius: 50%;
					width: 12px !important;
					height: 12px !important;
					display: inline-block !important;
					margin-right: 5px;
				}
				.legend-text {					
					font-weight: 500;
					font-size: 13px;
					line-height: 16px;
					letter-spacing: -0.02em;
					color: #081D16;
					
					@media only screen and (max-width: 575px) {
						font-size: 10px;
						line-height: 12px;
					}
				}
			}
		}		
		.dataCenterValue {
			position: absolute;
			width:100%;
			left: 50%;
			transform: translateX(-50%);
			bottom: 14%;
			text-align: center;
			font-weight: 700;
			font-size: 50px;
			line-height: 36px;
			letter-spacing: -0.02em;
			color: ${({ theme }) => theme.colors.themeColor2};
			@media only screen and (max-width: 1600px) {
				bottom: 0%;
			}		
			@media only screen and (max-width: 1600px) {
				bottom: 14%;
			}
			@media only screen and (max-width: 1200px) {
				font-size: 30px;
				line-height: 30px;
				bottom: 24%;
			}
			@media only screen and (max-width: 992px) {
				font-size: 30px;
				line-height: 30px;
				bottom: 13%;
			}
			@media only screen and (max-width: 768px) {
				font-size: 24px;
				line-height: 24px;
				bottom: 0%;
			}
			@media only screen and (max-width: 575px) {
				font-size: 30px;
				line-height: 30px;
				bottom: 0%;
			}
			span {
				font-weight: 500;
				font-size: 14px;
				color: ${({ theme }) => theme.colors.themeColor2};
				opacity: 0.6;
			}
		}		
	}
	// Global Table status Tags colors pending *******/
	span.successful, .approved{
		background: #e1fcef !important;
		color: #14804a !important;
	}
	span.rejected {
		background: #fff1f0 !important;
		color: #cf1322 !important;
	}
	span.pending, .pending_for_analysis{
		background: #FDE9CB !important;
		color: #E78900 !important;
	}
	span.allocated {
		background: #FFE9DA !important;
		color: #7A0E27 !important;
		border-color: #b7eb8f;
	}
	span.analysed {
		background: #FFFCDA !important;
		color: #7A670E !important;
	}
	span.letter_created {
		background: #FFFCDA !important;
		color: #7A670E !important;
	}
	span.letter_sent {
		border-radius: 5px;
		border: 0.5px solid rgba(56, 160, 108, 0.30);
		background: #E1FCEF;
		box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
		color: #38A06C;
	}
	span.No {
		background: #fff1f0 !important;
		color: #cf1322 !important;
		border:1px solid;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	span.Yes {
		background: #e1fcef !important;
		color: #38A06C !important;
		border:1px solid;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.labelHeading{
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		font-family: ${({ theme }) => theme.CQColors.fontInter};
	}
	.btnActive {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor8} 20.31%,
			${({ theme }) => theme.colors.themeColor25} 100%
		) !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		color:${({ theme }) => theme.colors.white} !important;
		
	}
	.btnActive img{
		filter: invert(0) !important;	
	}
	.largeInputForms {
		width: 100%;
		position: relative;
		border-radius: 10px !important;
		height: 44px !important;
		.ant-picker-input > input {
			line-height: 28px !important;
			font-size: 16px !important;
			color: ${({ theme }) => theme.colors.themeColor2} !important;
		}
		&:hover,
		&:focus {
			border-color: ${({ theme }) => theme.colors.themeColor23} !important;
		}
	}
	button.xThemeButtonSubmit{
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		border-color: #FFF !important;
		border-radius: 5px !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		line-height: 21px !important;
		text-align: center !important;
		color: ${({ theme }) => theme.colors.white} !important;
		padding: 0px 20px !important;
		box-shadow: none !important;
		&:hover{
			background: ${({ theme }) => theme.CQColors.white} !important;
			border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
	button.xThemeCancelSubmit{
		background: ${({ theme }) => theme.colors.white}!important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border-radius: 5px !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		line-height: 21px !important;
		text-align: center !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		padding: 0px 20px !important;
		box-shadow: none !important;
		&:hover{
			background: ${({ theme }) => theme.CQColors.gradientBg} !important;
			border: 1px solid ${({ theme }) => theme.colors.themeColor8} !important;
			color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	.ant-modal-confirm {
		/* .ant-btn{
			&:hover{
				border-color: ${({ theme }) => theme.colors.menu2} !important;
			}
		} */
		.ant-btn-dangerous{
			background: ${({ theme }) => theme.colors.menu2};
			color: ${({ theme }) => theme.colors.white};
			border-color: ${({ theme }) => theme.colors.menu2};
			&:hover{
				background: ${({ theme }) => theme.colors.menu2} !important;
				color: ${({ theme }) => theme.colors.white} !important;
			}
		}
		/* .ant-btn-default{
			background: ${({ theme }) => theme.colors.white};
			color: ${({ theme }) => theme.colors.menu2};
			border-color: ${({ theme }) => theme.colors.color3};
			&:hover{
				background: ${({ theme }) => theme.colors.menu2} !important;
				color: ${({ theme }) => theme.colors.white} !important;
			}
		} */
	}
/******************** End new theme ****************/	
	.marginTopMobile {
		@media only screen and (max-width: 991.99px) {
			margin-bottom: 100px;
		}
	}

	.marginTopMobileNoHeader {
		@media only screen and (max-width: 991.99px) {
			margin-top: -90px !important;
		}
	}
	.marginBottomMobile {
		@media only screen and (max-width: 991.99px) {
			margin-bottom: 70px !important;
		}
	}
	.marginNone {
		@media only screen and (max-width: 991.99px) {
			margin-top: -70px !important;
		}
	}
	.nav-link {
		color: ${({ theme }) => theme.colors.menu1};
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		&:hover {
			color: ${({ theme }) => theme.colors.menu2} !important;
			font-weight: 600;
		}
	}
	.nav-link.active {
		color: ${({ theme }) => theme.colors.menu2} !important;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		line-height: 24px;
	}
	
	.ant-select.ant-select-in-form-item,
	.ant-input,
	.ant-picker,
	.ant-select-selector,
	.ant-input-affix-wrapper {
		background: transparent !important;
	}
	

	.textArea{
		border-radius: 20px;
		border: 1px solid rgba(0, 0, 0, 0.10);
		background: ${({ theme }) => theme.colors.white} !important;
		box-shadow: 0px 2px 10px 0px rgba(25, 15, 64, 0.05);
		padding:10px 15px !important;
	}
	.iconResp{
		width:35px;
		@media only screen and (max-width: 769px) {
			width:36px;
		}
	}
	p.modalPara1{
		color: rgba(33, 34, 38, 0.60);
		font-family: ${({ theme }) => theme.colors.fontInter};
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 22px;
	}
	.confirmModal {
		.ant-btn{
			border-radius: 25px !important;	
		}
		.ant-btn-default{
			background: ${({ theme }) => theme.colors.white};
			border: 1px solid ${({ theme }) => theme.colors.secondaryColor};
			color: ${({ theme }) => theme.colors.menu2};
		};
		.ant-btn-dangerous{
			background: ${({ theme }) => theme.colors.secondaryColor} !important;
			color: ${({ theme }) => theme.colors.white} !important;
		};

	}
	.slideBox {
		overflow: hidden;
		@media only screen and (min-width: 2000.99px) {
			margin-top:5%;
		}
		@media (max-width: 768.99px) {
			padding-top:7%;
		}
		@media (max-width: 992.99px) {
			padding-top:3%;
		}
		@media (max-width: 1024.99px) {
			padding-top:3%;
		}
	}
	.slideUp {
		
		position: relative;
		transition: all .5s ease-out;
	}
	.slideDown {
		position: relative;
		transition: all .5s ease-out;
		height: 100%;
	}
	.top-0{
		top:0;
	}
	.bottom-0{
		position: relative;
		bottom:0 !important;
	}
	.top-100{
		top:100%!important;
	}
	.bottom-100{
		position: absolute;
		bottom:100% !important;
		z-index: -1;
	}
	.ant-layout-sider-children{
		overflow-y: scroll;
	}
	.ant-layout-sider-children::-webkit-scrollbar {
		width: .2em; 
	}	
	.ant-layout-sider-children::-webkit-scrollbar,
	.ant-layout-sider-children::-webkit-scrollbar-thumb {
		overflow:visible;
		border-radius: 4px;
	}
	.ant-layout-sider-children::-webkit-scrollbar-thumb {
		background: rgba(0,0,0,.2); 
	}
	.cover-bar {
		position: absolute;
		background: ${({ theme }) => theme.colors.bodyBg};
		height: 100%;  
		top: 0;
		right: 0;
		width: .2em;
		-webkit-transition: all .5s;
		opacity: 1;
	}
	.customScroll:hover .cover-bar {
		opacity: 0;
		-webkit-transition: all .5s;
	}
	
	
	${
		'' /* .customScroll::-webkit-scrollbar {
		width: 2px !important;
	}
	.customScroll:hover {
		overflow-y:auto !important;
	}
	.customScroll::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
		border-radius: 10px;
		background-color: ${Theme.colors.color3} !important;
	}
	.customScroll::-webkit-scrollbar-thumb {
		height: 5px;
		background-color: ${Theme.colors.color4};
		border-radius:5px;
	}
	.customScroll::-webkit-scrollbar-thumb:hover {
		background-color: ${Theme.colors.color2};
	} */
	}

	.customHorizontalScroll ::-webkit-scrollbar {
		height: 5px !important;
	}
	.customHorizontalScroll ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
		border-radius: 10px;
		background-color: ${Theme.colors.color3} !important;
	}
	.customHorizontalScroll ::-webkit-scrollbar-thumb {
		width: 5px;
		background-color: ${Theme.colors.color4};
		border-radius:5px;
	}
	.customHorizontalScroll ::-webkit-scrollbar-thumb:hover {
		background-color: ${Theme.colors.color2};
	}

	.headerStyle {
		color: #000;
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: -0.36px;
	}
	.labelStyle{
		color: #171C26;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		padding-bottom: 0 !important;
	}
	.labelStyle .ant-form-item-label{
		padding:0px !important;
	}

	
	.subLabelStyle{
		color: #171C26;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
	}

	.feedbackText{
		color: #000;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 26px; /* 185.714% */
		letter-spacing: -0.28px;
		
	}

	.feedbackCardHeader{
		margin-left: 8px;
		color: #212226;
		font-family: Poppins;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 16px; /* 100% */
		letter-spacing: -0.32px;
	}
	.feedbackTextArea{
		border-radius: 20px;
		border: 1px solid rgba(0, 0, 0, 0.10);
		background: #FFF;
		box-shadow: 0px 2px 10px 0px rgba(25, 15, 64, 0.05);
		color: rgba(0, 0, 0, 0.40);
		font-family: Inter;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		line-height: 30px; /* 166.667% */
		letter-spacing: -0.36px;
		height:200px;
		padding:20px !important;
	}

	:where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:focus, :where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:focus-within{
		border: 0.1px grey !important;
		box-shadow: 0.5px 0.5px 2px 0.2px #888888;
	}

	:where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:focus, :where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:hover{
		border: 0.1px grey !important;
		box-shadow: 0.5px 0.5px 2px 0.2px #888888;
	}
	.ant-form-item-control-input-content .ant-switch-checked{
		background: ${({ theme }) => theme.colors.menu2};
		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.white};
			}
		}
	}
	
	:where(.css-dev-only-do-not-override-3mqfnx).ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled){
		background: ${({ theme }) => theme.colors.menu2};
		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.white};
			}
		}
	}
	
	.remove_important > .ant-form-item-required{
		color:green !important;
	}
	canvas{
		width:10%;
	}
	.overlayDrawerCloseBtn{
		display:none;
	}
	@media only screen and (max-width: 992px) {
		/********** Mobile overlay menu */    
		.overlayDrawerClose{
			position: fixed;
			display: block;
			width:100%;
			min-height: 100vh;
			top:0;
			right:0%;
			background-color: rgba(0, 0, 0, 0.7);
			animation-direction: normal;
			animation-name: cssAnimation;
			animation-duration:0.15s;
			z-index: 10;
		}
		.overlayDrawerCloseBtn{
			position: absolute;
			top:15px;
			right:20px;
			font-size:3rem !important;
			line-height:2rem;
			background:none !important;
			color: #FFF !important;
			font-weight: 200 !important;
			box-shadow:0px;
			padding:0px;
			display:block;
			border:none;
		}
        #root  .ant-layout-sider-collapsed + .overlayDrawerClose{
            display: block;
        }
        #root .ant-layout-sider-zero-width + .overlayDrawerClose{
            display: none;
        }
        .ant-layout-header{
            background:  ${({ theme }) => theme.colors.white};
        }
		
	}
	.shareModal .ant-card-body{
		padding:15px !important;
	}
	
	.tableHeader{
		color: #11263C;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 1.2; /* 114.286% */
	}
	
	.filter-sub-item{
		color: #11263C !important;
		font-family: Poppins;
		font-size: 12px !important;
		font-style: normal !important;
		font-weight: 500 !important;
		line-height: 18px !important; /* 150% */
		letter-spacing: 0.36px !important;
		margin: 5px auto;
	}
	.removeFormMargin{
		margin-bottom: 14px !important;
	}
	.ant-drawer-body{
		padding-top: 14px !important;
	}
	.ant-upload-select {
		width: 100% !important;
	}


	.confirmCoverage:hover {
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}

	ul.listCircule{
        margin: 0px;
        padding: 0px;
    }
    ul.listCircule li{
        list-style-type: disc;
		font-family: ${({ theme }) => theme.colors.fontPoppins};
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		font-size: 15px;
		font-weight: 400;
		line-height: 28px !important;
		margin-bottom: 5px !important;
    } 
    ${
		'' /* ul.listCircule li::before {
        content: "";
        border:2px solid #5E5E5E;
        border-radius: 50%;
        font-weight: bold;
        display: inline-block; 
        width: 0.7em;
        height:0.7em;
        margin-right:.5em;
        } */
	}
	.dashboard-img {
		height: 240px !important;
	}
	.config-text {
		color: #212226;
		font-family: Inter;
		font-size: 18px;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 28px; /* 155.556% */
	}
	.criteria_list {
		border-left: 5px solid #9B68BF;
		padding-left: 25px;
		height: 50px;
		width: 375px;
		display: flex;
		align-items: center;
		background:
			linear-gradient(90deg, rgba(207, 174, 223, 0.15) 0.1%, rgba(207, 174, 223, 0.00) 99.86%);
		@media only screen and (max-width: 768.99px) {
			padding: 15px !important;
		}
	}

	.criteria_sub_list {
		padding-left: 25px !important;
		@media only screen and (max-width: 768.99px) {
			padding:0px 15px !important;
		}
	}

	.criteria_list_title {
		color: #9B68BF;
		font-family: Inter;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		line-height: 28px;
	}

	.supporting_files .ant-upload-select {
		width: 102px !important;
		margin:0 !important;
	}

	.supporting_files .ant-upload-list-item-container {
		margin-right:12px !important;
		margin-bottom: 0 !important;
	}

	.ant-upload-list-item-container {
		margin-right: 19px !important;
	}

	:where(.css-dev-only-do-not-override-3mqfnx).ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
		color: #212226 !important;
	}

	.no-padding-card .ant-card-body{
		padding:0 !important;
	}

	#revnueModalUploadButton:hover{
		color: black !important;
	}
	.timeline-documents .ant-card-body{
		padding:15px;
	}
	#timeline-documents-hover .ant-card-body{
		padding:5px !important;
		display: flex;
		justify-content: center;
		height: 100%;
		background: none;
		box-shadow: none;
	}
	.timeline-upload .ant-upload-list{
		display: flex;
		flex-wrap: wrap;
		row-gap: 10px;
	}

	//Flip Card Timeline
	.front,.back{
		backface-visibility: hidden;
		transition: transform .6s linear;
	}
	.front {
		transform: perspective(600px) rotateY(0deg);
	}
	.back{
		 transform: perspective(600px) rotateY(-180deg); 
	}
	.toggle.rotated > .front{
		transform: perspective(600px) rotateY(180deg);
	}
	.toggle.rotated > .back{ 
		transform: perspective(600px) rotateY(0deg);
	}

	.supporting-docs-hover, .ant-image-mask{
		border-radius: 10px !important;
	}

	.image-container, .image-container_case_filing {
		position: relative;
	  }
	.imgBoxButton{
		background: #ffffff;
		border: 1px solid #d1d7e5;
		box-shadow: inset 0px -5px 2px #eeeff7 !important;
		border-radius: 10px;
		padding-bottom:5px;
	}
	  .image-container, .uploadText {
		position: relative;
		text-align:center;
		font-size: 12px;
		line-height:28px;
		color: rgb(0, 0, 0);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 75px;
	  }
	  .image-container {
		width: 100px;
		height: 100px;
	  }
	  
	  .supporting-docs-hover, .overlay, .overlay_case_filing {
		border-radius: 10px;
	  }
	  
	  .overlay, .overlay_case_filing {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5); /* Mask the image */
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity 0.3s ease;
	  }
	  
	  .image-container:hover .overlay, .image-container_case_filing:hover .overlay_case_filing {
		opacity: 1;
	  }
	  
	  .icon {
		color: white;
		font-size: 24px;
		margin: 0 5px;
		cursor: pointer;
	  }
	  
	.dashboard-picker.ant-picker{
		background: #FFFFFF !important;
		width: 240px !important;
		border-radius: 25px !important;
		margin: 0 5px !important;
		border: 1px solid rgba(6, 36, 66, 0.1) !important;
		color: #212226 !important;
		@media only screen and (max-width: 992.99px) {
			width: 100% !important;
		}
	}
	.dashboard-picker.ant-picker-input{
		color: #212226 !important;
	}
		.dashboard-picker .ant-picker-input > input {
		font-size: 14px !important; /* Adjust this size as needed */
	}
	#tooltip-card .ant-card-body{
		padding:5px !important;
		display: flex;
		justify-content: center;
		height: 100%;
		background: none;
		box-shadow: none;
	}
	ul.markData {
		margin: 0px;
		padding: 0px;
	}
	ul.markData li {
		display: list-item;
		list-style-type: none;
		padding-left: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		letter-spacing: -0.02em;
		color: #FFFF;
		text-align: left;
	}
	ul.markData li em {
		position: absolute;
		left: 0;
		margin-top: 10px;
		width: 10px;
		height: 10px;
		border-radius: 20px;
	}
	#tooltip-card ul.markData li em.color1 {
		background: #1f9254;
	}
	#tooltip-card ul.markData li em.color2 {
		background: #e5aa11;
	}
	#tooltip-card ul.markData li em.color3 {
		background: #e53711;
	}
	#tooltip-card ul.markData li em.color4 {
		background: #2F8DFA;
	}
	#tooltip-card ul.markData li em.color5 {
		background: #1FD0BF;
	}
	#tooltip-card ul.markData li em.color6 {
		background: #D5001A;
	}
	#tooltip-card.ant-tooltip-inner{
		padding:5px 20px
	}
	
	.case-filing:hover {
		cursor:pointer !important;
	}
	.normal-header .ant-list-header {
		font-size: 10px !important;
		padding: 10px !important;
		font-family: 'Inter', sans-serif !important;
		background: none !important;
	}
	// .custom-crop-modal .ant-modal-body .reactEasyCrop_CropArea {
	// 	width: 40px !important;
	// 	height: 40px !important;
	// }

	// .custom-crop-modal .ant-modal-body .reactEasyCrop_CropArea {
	// 	width: 40px !important;
	// 	height: 40px !important;
	// 	aspect-ratio: 1 / 1;
	// }

	.rpv-core__inner-pages{
		scrollbar-width:none !important;
	}
	.rpv-core__page-layer--single{
		margin:0 !important;
		width:100% !important;
	}
	:where(.css-dev-only-do-not-override-98ntnt).ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector {
		background: rgba(0, 0, 0, 0.04) !important;
	}
	:where(.css-dev-only-do-not-override-98ntnt).ant-picker-outlined.ant-picker-disabled {
		background: rgba(0, 0, 0, 0.04) !important;
	}
	:where(.css-dev-only-do-not-override-98ntnt).ant-input-outlined.ant-input-disabled, :where(.css-dev-only-do-not-override-98ntnt).ant-input-outlined[disabled] {
		background: rgba(0, 0, 0, 0.04) !important;
	}
	@media only screen and (max-width: 992.99px) {
        #getQust{
            width:100% !important; 
        }
    }
	
`;
//End new theme Global style

export const XPagination = styled(Pagination)`
	display: block !important;
	.ant-pagination-prev,
	.ant-pagination-next {
		background: #fff;
	}
	.ant-pagination-prev,
	.ant-pagination-next,
	.ant-pagination-disabled {
		border: 1px solid #bebebe;
		min-width: 20px;
		height: 20px;
		line-height: 10px;
	}

	.ant-pagination-disabled,
	.ant-pagination-prev,
	.ant-pagination-next {
		span svg {
			font-size: 10px;
		}
	}

	.ant-pagination-item {
		min-width: 20px;
		border: 1px solid #bebebe;
		height: 20px;
		line-height: 20px;
		background: #fff;
		margin-inline-end: 15px;
	}
	.ant-pagination-item a {
		padding: 0px;
		font-size: 11px;
	}
	.ant-pagination-item-active {
		border-color: #007299 !important;
		// color: ${({ theme }) => theme.colors.bgButton1} !important;
		// color: #007299 !important;
	}
`;
export const XContainer = styled(Container)`
	// margin-left: 10px;
	padding: 0px 30px;
	@media only screen and (max-width: 768.99px) {
		padding: 0px 15px;
	}
	@media only screen and (min-width: 1920.99px) {
		width: 1800px;
	}
	@media only screen and (min-width: 2000.99px) {
		width: 100%;
	}
`;
export const XButton = styled(Button)`
	width: 100%;
	border-radius: 50px !important;
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	color: ${({ theme }) => theme.CQColors.white};
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	padding: 10px 0px;
	height: auto;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: -0.28px;
	&:hover {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;
export const XButton2 = styled(Button)`
	width: 100%;
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	padding: 12px 0px;
	height: auto !important;
	border-radius: 20px;
	border: 1px solid ${({ theme }) => theme.colors.color6};
	background: #007299;
	color: ${({ theme }) => theme.colors.white};
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 14px;
	letter-spacing: 0.28px;

	&:hover {
		// background: ${({ theme }) => theme.colors.menu2} !important;
		background: #007299 !important;
		color: ${({ theme }) => theme.colors.white} !important;
	}
`;
export const XShareButton = styled(Button)`
	width: 100%;
	border-radius: 10px #007299 !important;
	color: ${({ theme }) => theme.colors.white};
	font-family: ${({ theme }) => theme.colors.fontDM};
	padding: 10px 0px;
	height: auto;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: -0.28px;
	background: #007299 !important;
	&:hover {
		// background: ${({ theme }) => theme.colors.menu2} !important;
		background: #fff !important;
		color: #007299 !important;
	}
`;
export const FilterButton = styled(Button)`
	width: 100%;
	font-family: ${({ theme }) => theme.colors.fontInter} !important;
	padding: 12px 0px;
	height: auto !important;
	border-radius: 20px;
	// border: 1px solid #007299;
	// color: ${({ theme }) => theme.colors.menu2};
	color: #007299;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 14px;
	letter-spacing: 0.28px;

	&:hover {
		// border: 0.2px solid #007299 !important;
		color: #007299 !important;
	}
`;
export const XCardsTransparent = styled(Card)`
	border-radius: 20px !important;
	border: 1px solid ${({ theme }) => theme.colors.color3};
	background: rgba(255, 255, 255, 0.7) !important;
	.ant-card-body {
		padding: 30px !important;
		@media only screen and (max-width: 768.99px) {
			padding: 10px !important;
		}
	}
`;
export const XTable = styled(Table)`
	.ant-table {
		background: transparent;
	}
	// .ant-table-cell-row-hover {
	// 	background: none !important;
	// }
	.ant-table-thead > tr > th {
		color: ${({ theme }) => theme.colors.color4};
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 16px;
		text-transform: uppercase;
		border-top: 2px solid rgba(0, 0, 0, 0.05);
		border-radius: 0px !important;
		&::before {
			display: none;
		}
	}
	.ant-table-tbody > tr > td {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		border-bottom: 0px;
		color: ${({ theme }) => theme.colors.color7};
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 18px;
		letter-spacing: 0.42px;
	}
	.showDate img {
		margin-right: 10px;
		margin-top: -3px;
	}

	td.custom-border-left {
		// border-left: 10px solid green !important;
		// border-radius: 20px !important;
		padding: 0 !important;
	}

	td > .claim_category_line {
		height: 70px !important;
		display: grid;
		place-items: center;
	}
	td > .full {
		border-left: 5px solid #00a954 !important;
	}
	td > .neutral {
		border-left: 5px solid #e9ecef !important;
	}
	td > .rejected {
		border-left: 5px solid #ff1c1c !important;
	}
	td > .partial {
		border-left: 5px solid #ffd17b !important;
	}

	td > .triangle {
		// width: 0;
		// height: 0;
		display: grid;
		place-items: center;
		position: absolute;
		top: 0;
	}
	td > .in_process {
		border-right: 20px solid transparent;
		border-top: 20px solid #1f9254 !important;
	}
	td > .untimely {
		border-right: 20px solid transparent;
		border-top: 20px solid #db3a17 !important;
	}
	td > .escalation {
		border-right: 20px solid transparent;
		border-top: 20px solid #e57711 !important;
	}
	td > .at_risk {
		border-right: 20px solid transparent;
		border-top: 20px solid #e5aa11 !important;
	}

	.ant-pagination-prev,
	.ant-pagination-next {
		background: #fff;
	}
	.ant-pagination-prev,
	.ant-pagination-next,
	.ant-pagination-disabled {
		@media only screen and (max-width: 768.99px) {
			border: 1px solid #bebebe;
			min-width: 20px;
			height: 20px;
			line-height: 10px;
		}
	}

	.ant-pagination-disabled,
	.ant-pagination-prev,
	.ant-pagination-next {
		span svg {
			font-size: 10px;
		}
	}

	.ant-pagination-item {
		@media only screen and (max-width: 768.99px) {
			min-width: 20px;
			border: 1px solid #bebebe;
			height: 20px;
			line-height: 20px;
			background: #fff;
			margin-inline-end: 15px;
		}
	}
	.ant-pagination-item a {
		@media only screen and (max-width: 768.99px) {
			padding: 0px;
			font-size: 11px;
		}
	}
	.ant-pagination-item-active {
		border-color: #007299 !important;
		color: ${({ theme }) => theme.colors.bgButton1} !important;
	}
	.ant-pagination-options-size-changer {
		@media only screen and (max-width: 768.99px) {
			height: 20px;
		}
	}
	// .ant-pagination-item-active a {
	// 	color: #007299 !important; /* Set the text color for the active item */
	// }
	.ant-pagination .ant-pagination-item-active > a {
		color: #007299 !important;
	}
`;
export const XTag = styled(Tag)`
	border-radius: 4px;
	font-family: ${({ theme }) => theme.colors.fontInter};
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	letter-spacing: 0.36px;
	padding-left: 20px;
	border: none;
	&:before {
		content: '■';
		position: absolute;
		top: -1px;
		left: 5px;
		font-size: 10px;
	}
`;
export const XTag2 = styled(Tag)`
	border-radius: 4px;
	font-family: ${({ theme }) => theme.colors.fontInter};
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	letter-spacing: 0.36px;
	padding-left: 20px;
	&:before {
		content: '■';
		position: absolute;
		top: -1px;
		left: 5px;
		font-size: 10px;
	}
`;
export const XDropdown = styled(Dropdown)`
	text-align: center;
	color: ${({ theme }) => theme.colors.color8};
	font-size: 26px;
	font-weight: 600;
`;
export const XConfirmModal = styled(Modal)``;

export const XForm = styled(Form)`
	label {
		color: ${({ theme }) => theme.colors.color7} !important;
		font-size: 14px !important;
		font-style: normal;
		font-weight: 500 !important;
		line-height: normal;
	}
	input {
		border: 1px solid ${({ theme }) => theme.colors.color3};
		background: transparent;
		height: auto;
		padding-top: 10px;
		padding-bottom: 10px;
		@media only screen and (max-width: 768.99px) {
		}
	}
	button {
		display: inline-block;
		margin-left: 15px;
		border-radius: 20px;
		background: ${({ theme }) => theme.colors.menu2};
		color: #fff;
		font-size: 14px !important;
		padding: 10px 30px;
		height: auto;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		border: 1px solid ${({ theme }) => theme.colors.color6};
		&:hover {
			background: ${({ theme }) => theme.colors.menu2};
			color: #fff;
		}
		@media only screen and (max-width: 768.99px) {
		}
	}
	.ant-upload-list-item-action.ant-btn {
		background: none;
	}
	button.cancel {
		background: ${({ theme }) => theme.colors.white};
		color: #171c26;
	}
	.customLabel {
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 28px;
	}
	.customHeader {
		color: ${({ theme }) => theme.colors.menu2};
		background: #f3f6f9;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 28px;
		padding: 5px 15px;
	}
	.ant-switch {
		padding: 0px 5px;
		background: transparent;
		border: 1px solid ${({ theme }) => theme.colors.menu2};

		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.menu2};
			}
		}
	}
	button.ant-switch {
		&:hover {
			background: ${({ theme }) => theme.colors.menu2};
			.ant-switch-handle {
				&::before {
					background: ${({ theme }) => theme.colors.white};
				}
			}
		}
	}
	button.ant-switch-checked {
		background: ${({ theme }) => theme.colors.menu2};
		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.white};
			}
		}
	}
	.ant-picker-large .ant-picker-input > input {
		font-size: 14px !important;
	}
`;

export const XSelect = styled(Select)`
	.ant-select-selector {
		border: 1px solid rgba(6, 36, 66, 0.15) !important;
		background: transparent !important;
		box-shadow: none;
		min-height: 45px !important;
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px !important;
		font-style: normal;
		font-weight: 400 !important;
		line-height: 45px;
	}
`;
export const X2Select = styled(Select)`
	.ant-select-selector {
		border: 1px solid rgba(6, 36, 66, 0.15) !important;
		border-radius: 50px !important;
		background: transparent !important;
		box-shadow: none;
		min-height: 45px !important;
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px !important;
		font-style: normal;
		font-weight: 400 !important;
		line-height: 45px;
	}
`;

export const XModal = styled(Modal)`
	.ant-modal-title {
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.36px;
	}
	label {
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px !important;
		font-weight: 500 !important;
	}
	.modalButton {
		width: 100%;
		position: relative;
		margin: 0px;
		display: block;
		color: ${({ theme }) => theme.colors.white};
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.36px;
	}
	.ant-modal-content {
		border-radius: 20px !important;
	}
	.ant-modal-footer {
		.ant-btn {
			border-radius: 20px;
			height: 40px;
			padding: 0px 30px;
			font-size: 14px;
			font-style: normal;
			font-weight: 500;
			line-height: 20px;
			letter-spacing: 0.28px;
		}
		.ant-btn-primary {
			border: 1px solid ${({ theme }) => theme.colors.color6};
			background: ${({ theme }) => theme.colors.menu2};
			&:hover {
				border: 1px solid ${({ theme }) => theme.colors.color6};
				background: ${({ theme }) => theme.colors.menu2};
			}
		}
		.ant-btn-default {
			border-color: ${({ theme }) => theme.colors.color6};
			background: ${({ theme }) => theme.colors.white};
			box-shadow: 0px 0px 0px 1px rgba(70, 79, 96, 0.32),
				0px 5px 5px 0px rgba(0, 0, 0, 0.1);
			color: ${({ theme }) => theme.colors.menu2};
			&:hover {
				border-color: ${({ theme }) => theme.colors.menu2};
				background: ${({ theme }) => theme.colors.menu2};
				color: ${({ theme }) => theme.colors.white};
			}
		}
	}
`;
export const XSwitch = styled(Switch)`
	&.ant-switch-checked {
		background-color: #007299 !important;
		border: none !important;
	}
	&:not(.ant-switch-checked) {
		background-color: #d9d9d9 !important; /* Set your desired color for unchecked state */
		border: none !important;

		.ant-switch-handle::before {
			background-color: #fff !important; /* Unchecked handle color */
		}
	}
	.ant-switch-inner .ant-switch-inner-unchecked {
		color: black !important;
	}
`;
export const XCardsCaseBg = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;
	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 10px !important;
		}
	}
`;
export const XCardsCriteriaBg = styled(Card)`
	border-radius: 20px;
	border: none;
	.ant-card-body {
		border-radius: 20px;
		background: ${({ theme }) => theme.colors.white};
		box-shadow: 0px 2px 10px 0px rgba(25, 15, 64, 0.05);
		padding: 30px !important;
		padding-left: 0 !important;
		@media only screen and (max-width: 768.99px) {
			padding: 15px !important;
			padding-left: 0 !important;
		}
	}
`;

export const XCardsData = styled(Card)`
	border-radius: 20px;
	border: none;
	padding: 10px;
	.ant-card-body {
		border-radius: 20px;
		background: ${({ theme }) => theme.colors.white};
		box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
		padding: 30px !important;
		@media only screen and (max-width: 768.99px) {
			padding: 0 !important;
		}
	}
`;
export const XSelectRounded = styled(Select)`
	.ant-select-selector {
		border-radius: 25px !important;
		border: 1px solid rgba(6, 36, 66, 0.15) !important;
		background: transparent !important;
		box-shadow: none;
		height: 40px !important;
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px !important;
		font-style: normal;
		font-weight: 400 !important;
		line-height: 16px;
	}
	@media only screen and (min-width: 768.99px) {
	}
`;

export const XAutoComplete = styled(AutoComplete)`
	width: 100%;
	.ant-input {
		border-radius: 25px;
		border: 1px solid rgba(6, 36, 66, 0.15);
		box-shadow: none;
		height: 40px;
	}
	background: ${({ theme }) => theme.colors.white};
	@media only screen and (min-width: 768.99px) {
	}
`;

export const XSearch = styled(Search)`
	width: 100%;
	.ant-input {
		border-radius: 25px;
		border: 1px solid rgba(6, 36, 66, 0.15);
		box-shadow: none;
		font-size: 14px !important;
		font-style: normal;
		font-weight: 400 !important;
		line-height: 16px;
	}
	.ant-input-wrapper {
		border-radius: 25px !important;
		border: 1px solid rgba(6, 36, 66, 0.15);
		box-shadow: none;
	}
	.ant-input-affix-wrapper {
		border: none;
	}

	.ant-input-affix-wrapper:hover,
	.ant-input-affix-wrapper:focus,
	.ant-input-affix-wrapper:focus-within {
		border: none !important;
		box-shadow: none !important;
		border-color: none !important;
	}

	.ant-input-search-button {
		border-radius: 25px !important;
		border: 1px solid rgba(6, 36, 66, 0.15);
		box-shadow: none;
		// background: ${({ theme }) => theme.colors.menu2};
		background: #007299;
	}

	.ant-input-search-button:hover {
		border-radius: 25px !important;
		border: 1px solid rgba(6, 36, 66, 0.15);
		box-shadow: none;
		// background: ${({ theme }) => theme.colors.menu2} !important;
		background: #007299 !important;
	}
	.ant-input-search-button:focus-visible {
		border-radius: 25px !important;
		border: 1px solid rgba(6, 36, 66, 0.15);
		box-shadow: none;
		// background: ${({ theme }) => theme.colors.menu2} !important;
		background: #007299 !important;
	}
	// .ant-input-group-addon:last-child {
	// 	inset-inline-start: 95px !important;
	// }

	background: ${({ theme }) => theme.colors.white};
`;

export const XAlertBar = styled.div(`
	position: fixed;
	border-radius: 5px;
	box-sizing: border-box;
	color: white;
	font-size: 1em;
	margin: 0 auto;
	margin-bottom: 1em;
	padding: 0.5em;
	width: 100%;
	top: 0;
	z-index: 1;
	display: none;
    
	.alert-success {
	  background-color: #e67e22;
	  text-align: center;
	}
`);

export const XRoundButton = styled(Button)`
	background: ${({ theme }) => theme.colors.white} !important;
	border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
	color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	width: 32px !important;
	height: 32px !important;
	padding: 4px 0px !important;
	svg {
		margin-top: 3px !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}
	&:hover {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		svg {
			color: ${({ theme }) => theme.CQColors.white} !important;
		}
	}
`;
export const XList = styled(List)`
	.ant-list-item {
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: start;
		padding: 15px;
		font-family: 'Inter', sans-serif !important;
	}
	@media only screen and (max-width: 768.99px) {
		.ant-list-item {
			padding-left: 50px !important;
		}
		.ant-list-item label {
			margin-left: -40px !important;
		}
	}
	.ant-list-header {
		font-size: 14px;
		font-weight: 600;
		padding: 15px 20px !important;
		border-radius: 15px 15px 0px 0px;
		font-family: 'Inter', sans-serif !important;
		/* background: var(
			--Linear,
			linear-gradient(
				90deg,
				rgba(105, 234, 203, 0.15) 0%,
				rgba(234, 204, 248, 0.15) 48%,
				rgba(102, 84, 241, 0.15) 100%
			)
		); */
		background: #fff;
	}
`;
export const XCircle = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	line-height: 20px;
	padding: 0px;
	border-radius: 50%;
	border: 1px solid #2122261a;
	text-align: center;
	margin-right: 12px;
	font-size: 12px;
	line-height: 12px;
	@media only screen and (max-width: 768.99px) {
		position: absolute;
		left: 10px;
		width: 30px;
		height: 30px;
		padding: 0px !important;
	}
`;
export const XLabel = styled.span`
	font-size: 14px !important;
	font-weight: 600 !important;
	font-family: 'Inter', sans-serif !important;
`;
export const XModalTitle = styled.div`
	font-size: 18px !important;
	font-weight: 600 !important;
	font-family: 'Inter', sans-serif !important;
`;
export const XModalSubtitle = styled.div`
	font-size: 13px !important;
	font-weight: 500 !important;
	font-family: 'Inter', sans-serif !important;
`;
export const XAffix = styled(Affix)`
	&.zIndex .ant-affix {
		z-index: 11111;
	}
	&.manageResponsive {
		@media only screen and (max-width: 993px) {
			z-index: -9 !important;
		}
		.ant-affix {
			margin-top: 0px !important;
			@media only screen and (max-width: 993px) {
				margin-top: 85px !important;
			}
		}
	}
	/* &.mobileScrollAffix {
		@media only screen and (max-width: 993px) {
			.ant-affix {
				position: relative !important;
				width: 100% !important;
				height: 100% !important;
				top: auto !important;
			}
			.scrollAfix {
				position: relative !important;
				max-height: 100% !important;
				z-index: 99;
			}
		}
	} */
`;
// export const XAffix = styled.div``;

export const ChatButton = styled(Button)`
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	position: fixed;
	right: 10px;
	bottom: 30px;
	cursor: pointer;
	border: 0px;
	background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	color: ${({ theme }) => theme.CQColors.white} !important;
	height: 50px;
	width: 50px;
	border-radius: 50%;
	box-shadow: 0 2px 8px 0 ${({ theme }) => theme.CQColors.secondaryColor};
	svg {
		font-size: 20px !important;
	}

	.ant-btn-text {
		background: none !important;
		border: 0px;
	}
	&:active,
	&:focus,
	&:hover {
		outline: none;
		box-shadow: 0px;
		border: 0px;
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		svg,
		img {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			filter: ${({ theme }) => theme.CQColors.imgFilterColor} !important;
		}
	}

	/* .mobileClose {
		display: none;
		@media only screen and (max-width: 768.99px) {
			display: block;
		}
	} */
	@media only screen and (max-width: 768.99px) {
		bottom: 80px;
		/* .hideMobileClose {
			display: none;
		}
		.mobileClose {
			position: fixed;
			top: 25px;
			right: 25px;
		} */
	}
`;
export const ChatBoxWrap = styled.div`
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	position: fixed;
	width: 350px;
	top: 10px;
	right: 10px;
	z-index: 99999;
	background: #fff;
	border-radius: 20px;
	/* @media only screen and (max-width: 768.99px) {
		width: 100%;
		right: 0;
		top: 0px;
		height: 70px;
	}  */
	@media only screen and (max-width: 768.99px) {
		background: transparent;
		position: fixed;
		width: calc(100% + 60px);
		min-width: 350px;
		top: 0px;
		right: auto;
		z-index: 99999;
	}
`;
export const XCardSummaryEdit = styled(Card)`
	background: #f7f8fa;
	border-radius: 10px;
	font-family: ${({ theme }) => theme.colors.fontInter};
	color: ${({ theme }) => theme.colors.menu2};
	font-weight: 400;
	font-size: 14px;
	line-height: 30px;
	letter-spacing: -0.02em;
	@media only screen and (max-width: 768.99px) {
		.ant-card-body {
			padding: 0px 0px !important;
		}
	}
`;
export const XCardsCase = styled(Card)`
	border-radius: 0px !important;
	border: none;
	background: transparent !important;
	.ant-card-body {
		padding: 0px !important;
		@media only screen and (max-width: 768.99px) {
		}
	}
	.title {
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		color: #212226;
	}
`;
export const XSelectAddCase = styled(Select)`
	.ant-select-selector {
		border: 1px solid rgba(6, 36, 66, 0.15) !important;
		background: #fff !important;
		box-shadow: none;
		color: ${({ theme }) => theme.CQColors.primaryColor};
		font-size: 14px !important;
		font-style: normal;
		font-weight: 400 !important;
	}
`;
export const XCardsAddCaseInner = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 10px !important;
	border: 1px solid rgba(18, 18, 73, 0.15);
	background: #ffffff !important;
	.ant-card-body {
		padding: 30px !important;
		@media only screen and (max-width: 768.99px) {
			padding: 10px !important;
		}
	}
	.customHr {
		border-top: 1px dashed #11263c;
		opacity: 0.2;
	}
`;
export const XCustomHeader = styled.section`
	width: 100%;
	position: relative;
	background: #fff;
	margin-top: -20px;
	padding: 15px 60px;
	z-index: 0;
	@media only screen and (max-width: 991.99px) {
		margin-top: 70px;
		padding: 15px;
	}
`;

export const XTabs1 = styled(Tabs)`
	/* Style the tab list (labels of each tab) */
	&.child-tabs {
		.ant-tabs-nav {
			color: #007299 !important;
		}
		/* Style each tab item (the individual tab) */
		.ant-tabs-tab {
			/* Change the background color on hover */
			background-color: transparent !important;
			&:hover {
				background-color: transparent !important;
				.ant-tabs-tab-btn {
					color: #007299 !important;
				}
			}

			/* Style active tab */
			&:active {
				color: #007299 !important;
			}
		}
		.ant-tabs-tab-active {
			color: #007299 !important;
			/* background-color: ${({ theme }) =>
				theme.colors.white} !important; */
			background-color: unset !important; /* Resets background to default */
		}
		.ant-tabs-tab-active .ant-tabs-tab-btn {
			color: #007299 !important;
			transition: none !important;
		}
		/* Style the ink bar (line below active tab) */
		.ant-tabs-ink-bar {
			background: #007299 !important; /* Change the underline color */
			// height: 4px; /* Adjust the height of the underline */
		}
		.ant-tabs-nav .ant-tabs-nav-list {
			transition: none !important;
			// color: #007299 !important;
		}
		.ant-tabs-tab-btn {
			color: #000000 !important;
		}
	}
`;

export const XSteps = styled(Steps)`
	// .ant-steps-item .ant-steps-item-icon {
	// 	background-color: #e6f1f5 !important; /* Color for inactive steps */
	// }

	/* Active step */
	.ant-steps-item-active .ant-steps-item-icon {
		background-color: #007299 !important; /* Color for active steps */
		color: #fff !important;
	}
	// .ant-steps-item .ant-steps-icon {
	// 	color: #007299 !important;
	// }
	.ant-steps-item-active .ant-steps-icon {
		color: #fff !important;
	}

	// .ant-steps-item-finish
	// 	.ant-steps-item-content
	// 	.ant-steps-item-title::after {
	// 	background-color: #007299 !important;
	// }
`;

export const XNewUpload = styled(Upload)`
	.ant-upload-list .ant-upload-list-picture-card {
		.ant-upload .ant-upload-select {
			background: red !important;
			border: none !important;
		}
	}
`;

export const XUploadCustom = styled(Upload)`
	.ant-upload-list-item-container {
		position: absolute;
		width: 100% !important;
		display: block !important;
	}
	.ant-upload-list-item-container {
		background: #fff !important;
	}
`;

export const CustomUpload = styled.div`
	width: 150px;
	height: 150px;
	border: 2px solid #007299; // Border color and width
	border-radius: 8px; // Optional: make the corners rounded
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const OutlineCircle = styled.div`
	position: relative;
	border: 1px solid lightgrey;
	border-radius: 50%;
	width: 25px;
	height: 25px;
`;
export const XNextPrevBtn = styled(Button)`
	border-radius: 50px !important;
	background: #007299 !important;
	color: ${({ theme }) => theme.colors.white};
	font-family: ${({ theme }) => theme.colors.fontDM};
	padding: 10px 0px;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px;
	letter-spacing: -0.28px;
	span {
		display: masonry !important;
	}
	&:hover {
		background: #007299 !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: #007299 !important;
	}
	svg {
		margin-top: -4px;
	}
	@media only screen and (max-width: 576.99px) {
		margin: 5px !important;
	}
`;
/* Responsive pages style*/
export const XThemeMobileDashboard = styled.div`
	display: none;
	@media only screen and (max-width: 991.99px) {
		display: block;
		border-bottom: 1px dotted ${({ theme }) => theme.colors.themeColor23};
		padding: 10px 0px;
	}
`;

export const XThemeMobileTableCard = styled(Card)`
	width: 100%;
	position: relative;
	margin-bottom: 16px;
	background: ${({ theme }) => theme.colors.white} !important;
	border: 1px solid ${({ theme }) => theme.colors.themeColor23};
	border-radius: 15px;
	.ant-card-body {
		padding: 24px !important;
	}
	.title1 {
		font-size: 14px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor2};
		opacity: 0.85;
		text-transform: capitalize;
		span {
			font-size: 16px;
			font-weight: 600;
			line-height: 20px;
			opacity: 1;
		}
		svg {
			color: ${({ theme }) => theme.colors.themeColor8};
		}
	}
	.caseGraph {
		/* margin-top: 5px; */
		ul.barGraph {
			width: 100%;
			position: relative;
			margin: 0px;
			padding: 0px;
			background: transparent;
			overflow: auto;
			border-radius: 20px;
			box-shadow: inset 0 0 15px 0 ${({ theme }) => theme.colors.bodyBg};
			color: ${({ theme }) => theme.colors.white};
			align-items: center;
		}
		ul.barGraph li {
			justify-content: center;
			align-items: center;
			list-style-type: none;
			display: flex !important;
			float: left;
			box-shadow: inset 0px 12px 25px 5px rgba(0, 0, 0, 0.1);
			animation: wave 2s linear alternate;
			transform: translate3d(0, 0, 0);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-weight: 500;
			font-size: 12px;
			height: 100% !important;
			height: 18px;
			line-height: 18px !important;
			/* vertical-align: middle; */
		}
		@keyframes wave {
			2% {
				transform: translateX(1);
			}

			25% {
				transform: translateX(-25%);
			}

			50% {
				transform: translateX(-50%);
			}

			75% {
				transform: translateX(-25%);
			}

			100% {
				transform: translateX(1);
			}
		}
		ul.barGraph li.step1 {
			background: ${({ theme }) => theme.colors.themeColor13};
			border-right: 1px solid ${({ theme }) => theme.colors.white};
		}
		ul.barGraph li.step2 {
			background: ${({ theme }) => theme.colors.themeColor12};
			border-right: 1px solid ${({ theme }) => theme.colors.white};
		}
		ul.barGraph li.step3 {
			background: ${({ theme }) => theme.colors.themeColor10};
		}
		ul.barGraph li.step4 {
			/* background: #3b82f6;
		border-right: 1px solid ${({ theme }) => theme.colors.white}; */
			background: ${({ theme }) => theme.colors.themeColor13};
			border-right: 1px solid ${({ theme }) => theme.colors.white};
		}
		ul.barGraph li.step5 {
			/* background: #19dae7;
		border-right: 1px solid ${({ theme }) => theme.colors.white}; */
			background: ${({ theme }) => theme.colors.themeColor12};
			border-right: 1px solid ${({ theme }) => theme.colors.white};
		}
		ul.barGraph li.step6 {
			/* background: #d5001a;
		border-right: 1px solid ${({ theme }) => theme.colors.white}; */
			background: ${({ theme }) => theme.colors.themeColor10};
		}
	}
`;

export const XThemeMobileScrollCard = styled.div`
	width: 100%;
	position: relative;
	@media only screen and (max-width: 991.99px) {
		.ant-row {
			width: 100%;
			overflow: auto;
			overflow-y: hidden;
			flex-flow: nowrap;
			white-space: nowrap;
			padding: 0px;
			.mobileScrollCard {
				display: inline;
				max-width: 90% !important;
				padding: 0px !important;
				margin-right: 15px;
				&:last-child {
					margin-right: 0;
				}
			}
		}
	}
`;

export const XThemeMobileListCard = styled.div`
	width: 100%;
	position: relative;
	background: transparent;
	@media only screen and (max-width: 991.99px) {
		padding: 20px;
		p.para1 {
			margin: 0px;
			font-weight: 500;
			font-size: 14px;
			line-height: 18px;
			letter-spacing: -0.02em;
			color: ${({ theme }) => theme.colors.themeColor2};
			font-family: ${({ theme }) => theme.colors.fontPoppins};
		}
		p.para2 {
			margin: 0px 0px 5px 0px;
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			letter-spacing: -0.02em;
			color: ${({ theme }) => theme.colors.themeColor2} !important;
			opacity: 0.8;
			font-family: ${({ theme }) => theme.colors.fontPoppins};
		}
		a {
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			letter-spacing: -0.02em;
			color: ${({ theme }) => theme.colors.themeColor2} !important;
			opacity: 0.8;
			font-family: ${({ theme }) => theme.colors.fontPoppins};
		}
		.mobileFancyCard {
			position: absolute;
			top: 0;
			right: 0;
			width: 90px;
			height: 90px;
			border-radius: 20px;
			background: transparent url(../images/mobile-card-fancy.png)
				no-repeat right top;
			text-align: end;
			svg {
				color: ${({ theme }) => theme.colors.themeColor8};
				font-size: 30px;
			}
		}
	}
`;
export const XThemeMobilePoliciesCodes = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;
	.ant-card-head {
		padding: 15px 24px;
		border-bottom: 1px dashed ${({ theme }) => theme.colors.themeColor23};
	}
	.cardImgBg {
		border-radius: 40px;
		width: 50px;
		height: 50px;
		background: ${({ theme }) => theme.colors.themeColor8};
		text-align: center;
		line-height: 50px;
	}
	h4 {
		margin: 0px;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	h6 {
		margin: 0px;
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 36px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		&:before {
			content: '';
			display: inline-block;
			width: 10px;
			height: 10px;
			border: 1px solid ${({ theme }) => theme.colors.themeColor8};
			border-radius: 50%;
			margin-right: 10px;
		}
	}
	@media only screen and (max-width: 991.99px) {
	}
`;
